/* WENNYVISUAL // MISTIQU — Premium Theme */
(() => {
  const theme = window.theme || {};
  const wv_mistiqu = 'WENNYVISUAL // MISTIQU';
  theme.wv_mistiqu = wv_mistiqu;
  window.theme = theme;

  const SHOPIFY_PC_HIDE_CSS = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '#shopify-pc__banner__dialog',
    '#shopify-pc__prefs__dialog',
    '.shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '.shopify-pc__prefs',
    '.shopify-pc__prefs__dialog',
    '.shopify-pc-banner',
    '[id^="shopify-pc__"]',
    '[class*="shopify-pc__"]',
    'shopify-cookie-banner',
    'shopify-privacy-banner'
  ].join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important;height:0!important;max-height:0!important;overflow:hidden!important;opacity:0!important}';

  const hideShopifyPrivacyBanner = () => {
    if (!document.getElementById('wv-hide-shopify-pc')) {
      const style = document.createElement('style');
      style.id = 'wv-hide-shopify-pc';
      style.textContent = SHOPIFY_PC_HIDE_CSS;
      (document.head || document.documentElement).appendChild(style);
    }

    document
      .querySelectorAll(
        '#shopify-pc__banner, #shopify-pc__prefs, #shopify-pc__banner__dialog, #shopify-pc__prefs__dialog, .shopify-pc__banner, .shopify-pc__banner__dialog, .shopify-pc__prefs, .shopify-pc__prefs__dialog, .shopify-pc-banner, [id^="shopify-pc__"], [class*="shopify-pc__banner"], [class*="shopify-pc__prefs"]'
      )
      .forEach((el) => {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
  };

  hideShopifyPrivacyBanner();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideShopifyPrivacyBanner, { once: true });
  }
  const shopifyPcObserver = new MutationObserver(() => {
    if (shopifyPcObserver._raf) return;
    shopifyPcObserver._raf = requestAnimationFrame(() => {
      shopifyPcObserver._raf = 0;
      hideShopifyPrivacyBanner();
    });
  });
  shopifyPcObserver.observe(document.documentElement, { childList: true, subtree: true });

  const money = (cents) => {
    const amount = Number(cents);
    if (Number.isNaN(amount)) return '';

    const format = theme.moneyFormat || '${{amount}}';
    const dollars = Math.abs(amount) / 100;
    const sign = amount < 0 ? '-' : '';

    const grouped = (value, decimal, thousand, decimals) => {
      const fixed = decimals ? value.toFixed(2) : String(Math.round(value));
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousand}`);
      return decimals ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };

    const tokens = {
      amount: grouped(dollars, '.', ',', true),
      amount_no_decimals: grouped(dollars, '.', ',', false),
      amount_with_comma_separator: grouped(dollars, ',', '.', true),
      amount_no_decimals_with_comma_separator: grouped(dollars, ',', '.', false),
      amount_with_apostrophe_separator: grouped(dollars, '.', "'", true),
      amount_no_decimals_with_apostrophe_separator: grouped(dollars, '.', "'", false),
      amount_with_space_separator: grouped(dollars, ',', ' ', true),
      amount_with_period_and_space_separator: grouped(dollars, '.', ' ', true),
      amount_no_decimals_with_space_separator: grouped(dollars, '.', ' ', false)
    };

    let output = format;
    Object.keys(tokens)
      .sort((a, b) => b.length - a.length)
      .forEach((key) => {
        output = output.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), sign + tokens[key]);
      });

    if (output.includes('{{')) {
      output = output.replace(/\{\{\s*amount[^}]*\}\}/g, sign + tokens.amount);
    }

    return output;
  };

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animateMoney = (el, fromCents, toCents, finalLabel) => {
    if (!el) return;

    const from = Number(fromCents);
    const to = Number(toCents);
    const startValue = Number.isNaN(from) ? 0 : from;
    const endValue = Number.isNaN(to) ? 0 : to;
    const label = finalLabel || money(endValue);

    el.dataset.cents = String(endValue);
    el._displayCents = startValue;

    if (startValue === endValue || prefersReducedMotion()) {
      el._displayCents = endValue;
      el.textContent = label;
      return;
    }

    if (el._moneyFrame) window.cancelAnimationFrame(el._moneyFrame);
    el.textContent = money(startValue);

    const duration = 420;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - (1 - t) ** 3;
      const current = Math.round(startValue + (endValue - startValue) * eased);
      el._displayCents = current;
      el.textContent = t < 1 ? money(current) : label;
      if (t < 1) el._moneyFrame = window.requestAnimationFrame(tick);
    };

    el._moneyFrame = window.requestAnimationFrame(tick);
  };

  const saleBadgeMarkup = (price, compare, soldOut) => {
    if (soldOut) return `<span class="badge badge--sold-out">${theme.strings.soldOut || 'Sold out'}</span>`;
    if (!(Number(compare) > Number(price))) return '';
    const style = theme.saleBadgeStyle || 'badge';
    let label = theme.strings.sale || 'Sale';
    if (style === 'save') {
      label = (theme.strings.saleSave || 'Save [amount]').replace('[amount]', money(compare - price));
    } else if (style === 'percent') {
      const percent = Math.round(((compare - price) / compare) * 100);
      label = (theme.strings.salePercent || '-[percent]%').replace('[percent]', String(percent));
    }
    return `<span class="badge badge--sale">${label}</span>`;
  };

  const syncOptionRailFade = (scroller) => {
    if (!scroller) return;
    const rail = scroller.closest('[data-option-rail]');
    if (!rail) return;
    const max = scroller.scrollWidth - scroller.clientWidth;
    const overflow = max > 4;
    rail.classList.toggle('has-overflow', overflow);
    rail.classList.toggle('is-at-start', !overflow || scroller.scrollLeft <= 2);
    rail.classList.toggle('is-at-end', !overflow || scroller.scrollLeft >= max - 2);
  };

  const dragScrollBindings = new WeakMap();

  const unbindDragScroll = (scroller) => {
    if (!scroller) return;
    const binding = dragScrollBindings.get(scroller);
    if (!binding) {
      delete scroller.dataset.dragBound;
      return;
    }

    binding.stopMomentum?.();
    scroller.removeEventListener('pointerdown', binding.onPointerDown);
    scroller.removeEventListener('wheel', binding.onWheel);
    scroller.removeEventListener('click', binding.onClick, true);
    scroller.removeEventListener('dragstart', binding.onDragStart);
    if (binding.onScroll) {
      scroller.removeEventListener('scroll', binding.onScroll);
    }
    binding.observer?.disconnect();
    window.removeEventListener('pointermove', binding.onMove);
    window.removeEventListener('pointerup', binding.onUp);
    window.removeEventListener('pointercancel', binding.onUp);
    scroller.classList.remove('is-dragging');
    delete scroller.dataset.dragBound;
    delete scroller.dataset.dragMoved;
    dragScrollBindings.delete(scroller);
  };

  const bindDragScroll = (scroller) => {
    if (!scroller) return;
    if (dragScrollBindings.has(scroller) || scroller.dataset.dragBound === 'true') {
      /* Already bound — keep guard, refresh option-rail fades only. */
      if (!dragScrollBindings.has(scroller) && scroller.dataset.dragBound === 'true') {
        /* Stale flag without registry entry (should not happen); clear and rebind. */
        delete scroller.dataset.dragBound;
      } else {
        syncOptionRailFade(scroller);
        return;
      }
    }

    let active = null;
    let velocity = 0;
    let lastX = 0;
    let lastT = 0;
    let momentumRaf = 0;

    const stopMomentum = () => {
      if (momentumRaf) cancelAnimationFrame(momentumRaf);
      momentumRaf = 0;
    };

    const tickMomentum = () => {
      if (Math.abs(velocity) < 0.12) {
        momentumRaf = 0;
        velocity = 0;
        return;
      }
      scroller.scrollLeft -= velocity;
      velocity *= 0.94;
      const max = scroller.scrollWidth - scroller.clientWidth;
      if (scroller.scrollLeft <= 0 || scroller.scrollLeft >= max) {
        velocity = 0;
        momentumRaf = 0;
        return;
      }
      momentumRaf = requestAnimationFrame(tickMomentum);
    };

    const onMove = (event) => {
      if (!active) return;
      const dx = event.clientX - active.x;
      const dy = event.clientY - active.y;

      /* Lock to one axis so a vertical page-scroll does not get stolen. */
      if (!active.axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        active.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (active.axis === 'y') {
          onUp(event);
          return;
        }
      }
      if (active.axis !== 'x') return;

      const now = performance.now();
      const dt = Math.max(8, now - lastT);
      velocity = ((event.clientX - lastX) / dt) * 16;
      lastX = event.clientX;
      lastT = now;
      if (!active.moved) {
        active.moved = true;
        scroller.classList.add('is-dragging');
        try {
          if (active.pointerId != null) scroller.setPointerCapture(active.pointerId);
        } catch (error) {
          /* capture is optional */
        }
      }
      scroller.scrollLeft = active.start - dx;
      event.preventDefault();
    };

    const onUp = (event) => {
      const dragged = Boolean(active?.moved);
      scroller.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      try {
        if (event?.pointerId != null) scroller.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* already released */
      }
      active = null;
      if (dragged) {
        scroller.dataset.dragMoved = 'true';
        window.setTimeout(() => {
          delete scroller.dataset.dragMoved;
        }, 0);
        if (Math.abs(velocity) > 0.45 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          stopMomentum();
          momentumRaf = requestAnimationFrame(tickMomentum);
        }
      } else {
        velocity = 0;
      }
    };

    const onPointerDown = (event) => {
      if (event.pointerType !== 'touch' && event.button !== 0) return;
      if (event.target.closest('input, select, textarea')) return;
      const nested = event.target.closest('[data-drag-scroll]');
      if (nested && nested !== scroller) return;
      if (scroller.scrollWidth <= scroller.clientWidth + 2) return;
      stopMomentum();
      velocity = 0;
      lastX = event.clientX;
      lastT = performance.now();
      /* Do not setPointerCapture until the pointer actually drags — capture on
         pointerdown steals clicks from collection nav / filter links. */
      active = { x: event.clientX, y: event.clientY, start: scroller.scrollLeft, moved: false, pointerId: event.pointerId, axis: '' };
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp, { passive: true });
      window.addEventListener('pointercancel', onUp, { passive: true });
    };

    const onWheel = (event) => {
      if (event.ctrlKey || event.metaKey) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      if (scroller.scrollWidth <= scroller.clientWidth + 2) return;
      event.preventDefault();
      scroller.scrollLeft += event.deltaX;
    };

    const onClick = (event) => {
      if (scroller.dataset.dragMoved === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const onDragStart = (event) => {
      event.preventDefault();
    };

    scroller.dataset.dragBound = 'true';
    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('wheel', onWheel, { passive: false });
    scroller.addEventListener('click', onClick, true);
    scroller.addEventListener('dragstart', onDragStart);

    let onScroll = null;
    let observer = null;
    if (scroller.closest('[data-option-rail]')) {
      onScroll = () => syncOptionRailFade(scroller);
      scroller.addEventListener('scroll', onScroll, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(() => syncOptionRailFade(scroller));
        observer.observe(scroller);
        if (scroller.parentElement) observer.observe(scroller.parentElement);
      }
      requestAnimationFrame(() => {
        syncOptionRailFade(scroller);
        requestAnimationFrame(() => syncOptionRailFade(scroller));
      });
    }

    dragScrollBindings.set(scroller, {
      onPointerDown,
      onWheel,
      onClick,
      onDragStart,
      onScroll,
      onMove,
      onUp,
      observer,
      stopMomentum
    });
  };

  const parseSection = (html, selector) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  };

  const setAddLoading = (button, loading) => {
    if (!button) return;
    button.classList.toggle('is-loading', Boolean(loading));
    if (loading) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      if (!button.querySelector('[data-add-spinner]')) {
        const spinner = document.createElement('span');
        spinner.className = 'button__spinner';
        spinner.dataset.addSpinner = '';
        spinner.setAttribute('aria-hidden', 'true');
        button.append(spinner);
      }
      return;
    }
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    button.querySelector('[data-add-spinner]')?.remove();
    button.disabled = false;
  };

  const showAddError = (button, message) => {
    if (!button) return;
    const root = button.closest('.product-block, [data-quick-add-root], .product') || button.parentElement;
    let el = root?.querySelector('[data-add-error]');
    if (!el && root) {
      el = document.createElement('p');
      el.className = 'form__message form__message--error';
      el.dataset.addError = '';
      el.setAttribute('role', 'alert');
      button.insertAdjacentElement('afterend', el);
    }
    if (!el) return;
    el.hidden = false;
    el.textContent = message || theme.strings.cartError;
  };

  const clearAddError = (button) => {
    const root = button?.closest('.product-block, [data-quick-add-root], .product') || button?.parentElement;
    const el = root?.querySelector('[data-add-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  };

  const trapFocus = (container) => {
    if (!container) return () => {};
    const selectors = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    const getFocusable = () =>
      [...container.querySelectorAll(selectors)].filter(
        (el) => !el.hasAttribute('hidden') && !el.closest('[hidden]') && el.offsetParent !== null
      );
    const onKey = (event) => {
      if (event.key !== 'Tab') return;
      const items = getFocusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        last.focus({ preventScroll: true });
        event.preventDefault();
      } else if (!event.shiftKey && document.activeElement === last) {
        first.focus({ preventScroll: true });
        event.preventDefault();
      }
    };
    container.addEventListener('keydown', onKey);
    return () => container.removeEventListener('keydown', onKey);
  };

  const formatFreeShippingMessage = (template, amountCents) => {
    if (!template) return '';
    return template.replace(/\{\{\s*amount\s*\}\}/gi, money(amountCents));
  };

  const Cart = {
    _mutationChain: Promise.resolve(),
    _refreshing: null,
    _refreshQueued: false,
    _lastCart: null,

    enqueue(task) {
      const run = this._mutationChain.then(task, task);
      this._mutationChain = run.catch(() => {});
      return run;
    },

    async get() {
      const response = await fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(theme.strings.cartError);
      return response.json();
    },
    async add(id, quantity = 1) {
      return this.addItems([{ id, quantity }]);
    },
    async addItems(items) {
      return this.enqueue(async () => {
        const endpoint = theme.routes.cart_add_url.endsWith('.js')
          ? theme.routes.cart_add_url
          : `${theme.routes.cart_add_url}.js`;
        const payload = Array.isArray(items) && items.length > 1
          ? { items }
          : { id: items[0].id, quantity: items[0].quantity || 1 };
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          let message = theme.strings.cartError;
          try {
            const data = await response.json();
            if (data?.description || data?.message) message = data.description || data.message;
          } catch (_) {
            /* keep default */
          }
          throw new Error(message);
        }
        return response.json();
      });
    },
    async change(line, quantity) {
      return this.enqueue(async () => {
        const endpoint = theme.routes.cart_change_url.endsWith('.js')
          ? theme.routes.cart_change_url
          : `${theme.routes.cart_change_url}.js`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line, quantity })
        });
        if (!response.ok) throw new Error(theme.strings.cartError);
        return response.json();
      });
    },
    async update(payload) {
      return this.enqueue(async () => {
        const endpoint = theme.routes.cart_update_url.endsWith('.js')
          ? theme.routes.cart_update_url
          : `${theme.routes.cart_update_url}.js`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload || {})
        });
        let data = {};
        try {
          data = await response.json();
        } catch (_) {
          data = {};
        }
        if (!response.ok) {
          throw new Error(data.description || data.message || theme.strings.cartError);
        }
        return data;
      });
    },
    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
      });
      document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
        el.textContent = (theme.strings.cartCount || '[count]').replace('[count]', count);
      });
    },
    /* Only the drawer's contents are swapped, so the open panel, its focus
       trap and the scroll lock all survive the update. */
    async refresh() {
      if (this._refreshing) {
        this._refreshQueued = true;
        await this._refreshing;
        if (this._refreshQueued) {
          this._refreshQueued = false;
          return this.refresh();
        }
        return this._lastCart;
      }

      this._refreshing = this._doRefresh();
      try {
        this._lastCart = await this._refreshing;
        return this._lastCart;
      } finally {
        this._refreshing = null;
      }
    },
    async _doRefresh() {
      const drawer = document.querySelector('cart-drawer');
      const previous = drawer?.querySelector('[data-cart-subtotal]');
      const fromCents = previous
        ? Number(previous._displayCents ?? previous.dataset.cents)
        : 0;
      const previousSave = drawer?.querySelector('[data-cart-savings]');
      const fromSave = previousSave
        ? Number(previousSave._displayCents ?? previousSave.dataset.cents)
        : 0;

      if (drawer) {
        const liveNote = drawer.querySelector('[data-cart-note]');
        if (liveNote) {
          try {
            await this.update({ note: liveNote.value });
          } catch (_) {
            /* keep the in-progress refresh */
          }
        }
        const scroller = drawer.querySelector('.cart-drawer__body');
        const scrollTop = scroller ? scroller.scrollTop : 0;
        const response = await fetch(`${theme.routes.cart_url}?section_id=cart-drawer`);
        const html = await response.text();
        const incoming = parseSection(html, '[data-cart-content]');
        const target = drawer.querySelector('[data-cart-content]');
        const nextSubtotal = incoming?.querySelector('[data-cart-subtotal]');
        const toCents = nextSubtotal ? Number(nextSubtotal.dataset.cents) : null;
        const toLabel = nextSubtotal?.textContent?.trim() || '';
        const nextSave = incoming?.querySelector('[data-cart-savings]');
        const toSave = nextSave ? Number(nextSave.dataset.cents) : null;
        const toSaveLabel = nextSave?.textContent?.trim() || '';

        if (incoming && target) {
          target.replaceChildren(...incoming.childNodes);
          target.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => {
            el.classList.add('is-visible');
          });
          if (window.MediaStates?.initAll) window.MediaStates.initAll(target);
          drawer.syncCheckout?.();
          drawer.syncRecsNav?.();
          bindDragScroll(drawer.querySelector('[data-recommendations-row]'));
          drawer.querySelectorAll('recently-viewed').forEach((el) => {
            el._ready = false;
            el.revealFromCart?.();
          });
          const nextScroller = drawer.querySelector('.cart-drawer__body');
          if (nextScroller) {
            nextScroller.scrollTop = scrollTop;
            requestAnimationFrame(() => {
              nextScroller.scrollTop = scrollTop;
            });
          }
        }

        const live = drawer.querySelector('[data-cart-subtotal]');
        if (live && toCents != null) {
          animateMoney(live, Number.isNaN(fromCents) ? 0 : fromCents, toCents, toLabel);
        }

        const liveSave = drawer.querySelector('[data-cart-savings]');
        if (liveSave && toSave != null) {
          animateMoney(liveSave, Number.isNaN(fromSave) ? 0 : fromSave, toSave, toSaveLabel);
        }

        bindDragScroll(drawer.querySelector('[data-drag-scroll]'));
        Wishlist.sync(drawer);
      }

      /* Fetch cart after section/note work so badge count cannot lag behind later mutations. */
      const cart = await this.get();
      drawer?.updateFreeShipping?.(cart);
      this.updateCount(cart.item_count);
      return cart;
    },
    open() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open();
    }
  };

  const scrollLock = {
    count: 0,
    y: 0,
    lock() {
      if (this.count === 0) {
        this.y = window.scrollY || window.pageYOffset || 0;
        const root = document.documentElement;
        root.style.setProperty('--scroll-lock-top', `-${this.y}px`);
        root.classList.add('is-scroll-locked');
        document.body.classList.add('is-scroll-locked');
      }
      this.count += 1;
    },
    unlock() {
      if (this.count === 0) return;
      this.count -= 1;
      if (this.count === 0) {
        const y = this.y;
        this.reset();
        window.scrollTo(0, y);
      }
    },
    reset() {
      this.count = 0;
      this.y = 0;
      document.documentElement.classList.remove('is-scroll-locked');
      document.body.classList.remove('is-scroll-locked');
      document.documentElement.style.removeProperty('--scroll-lock-top');
      document.documentElement.style.removeProperty('--scrollbar-width');
    }
  };

  /* Color mode — fixed light palette (no shopper switcher). */
  const ColorMode = {
    root: document.documentElement,
    get default() { return 'light'; },
    get preference() { return 'light'; },
    get current() { return 'light'; },
    resolve() { return 'light'; },
    set() {
      this.root.dataset.theme = 'light';
      this.syncMetaColor();
      return 'light';
    },
    toggle() { return this.set(); },
    syncMetaColor() {
      const meta = document.querySelector('meta[name="theme-color"]');
      if (!meta) return;
      const color = getComputedStyle(this.root).getPropertyValue('--color-background').trim();
      if (color) meta.setAttribute('content', color);
    },
    init() { this.set(); }
  };

  /* Reveal system.
     Page/overlays: .reveal (+ .reveal--up).
     Product cards: .product-card-reveal with exactly one animation modifier. */
  /* Page animation helper — every overlay, drawer, and late-rendered
     component reads this so they share Theme Settings → Appearance. */
  const pageReveal = {
    name() {
      return document.documentElement.dataset.pageAnimation || theme.pageAnimation || 'domino';
    },
    className() {
      const name = this.name();
      if (name === 'none') return '';
      if (name === 'fade') return 'reveal';
      return 'reveal reveal--up';
    },
    play(root) {
      if (!root) return;
      if (reveal.enterLocked?.()) return;
      const group = root.matches?.('[data-reveal-group]')
        ? root
        : root.querySelector?.('[data-reveal-group]') || root;
      if (group instanceof Element && !group.hasAttribute('data-reveal-group')) {
        group.setAttribute('data-reveal-group', '');
      }
      group.querySelectorAll('.reveal, .product-card-reveal').forEach((el, index) => {
        if (!el.style.getPropertyValue('--reveal-index')) {
          el.style.setProperty('--reveal-index', String(index));
        }
      });
      if (this.name() === 'none') {
        group.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => el.classList.add('is-visible'));
        return;
      }
      reveal.play(group);
    }
  };

  const reveal = {
    observer: null,
    selector: '.reveal:not(.is-visible), .product-card-reveal:not(.is-visible)',

    enterLocked() {
      return document.documentElement.classList.contains('has-enter-page');
    },

    init() {
      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        document.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => el.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            /* Don't burn the entrance while Enter still covers the page. */
            if (this.enterLocked()) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
      );

      this.scan();
    },

    scan(root = document) {
      const scope = root === document ? document : root;
      if (!this.observer) {
        if (prefersReducedMotion()) {
          scope.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => el.classList.add('is-visible'));
        }
        return;
      }
      /* Enter gate still up — wait for replayAfterEnter(). */
      if (this.enterLocked()) return;

      scope.querySelectorAll(this.selector).forEach((el) => {
        if (el.closest('.search-overlay, .mobile-menu, .mega, .collection-sort')) return;
        if (el.closest('cart-drawer')) {
          el.classList.add('is-visible');
          return;
        }
        this.observer.observe(el);
      });
    },

    play(root) {
      if (!root) return;
      if (this.enterLocked()) return;
      const items = [...root.querySelectorAll('.reveal, .product-card-reveal')].filter(
        (el) => el.closest('[data-reveal-group]') === root
      );
      /* Include the group root when it is itself a reveal (modals / panels). */
      if (
        root.matches?.('.reveal, .product-card-reveal') &&
        root.hasAttribute('data-reveal-group') &&
        !items.includes(root)
      ) {
        items.unshift(root);
      }
      if (!items.length) return;

      items.forEach((el, index) => {
        const staggerIndex = Math.min(index, 19);
        if (el.classList.contains('product-card--animation-domino')) {
          if (!el.style.getPropertyValue('--card-reveal-index')) {
            el.style.setProperty('--card-reveal-index', String(staggerIndex));
          }
        } else if (!el.style.getPropertyValue('--reveal-index')) {
          el.style.setProperty('--reveal-index', String(staggerIndex));
        }
        el.classList.remove('is-visible');
      });

      /* Force a real style flush, then double-rAF so reopen always replays. */
      void root.offsetWidth;

      window.requestAnimationFrame(() => {
        void root.offsetWidth;
        window.requestAnimationFrame(() => {
          items.forEach((el) => el.classList.add('is-visible'));
        });
      });
    },

    reset(root) {
      if (!root) return;
      root.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => {
        el.classList.remove('is-visible');
        this.observer?.unobserve(el);
      });
    },

    /* After Enter exit — replay global page/card reveals so soft-nav destinations animate. */
    replayAfterEnter(root = document.getElementById('MainContent')) {
      if (!root) return;
      this.reset(root);
      root.querySelectorAll('.product[data-reveal-group]').forEach((group) => pageReveal.play(group));
      this.scan(root);
      bannerEntrance.scan(root);
    }
  };

  const bannerEntrance = {
    observer: null,
    selector: '.image-banner[data-entrance]:not([data-entrance="none"]):not(.is-entrance-in)',

    init() {
      this.scan();
    },

    scan(root = document) {
      const scope = root === document ? document : root;
      const banners = [...scope.querySelectorAll(this.selector)];
      if (!banners.length) return;

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        banners.forEach((el) => el.classList.add('is-entrance-in'));
        return;
      }

      if (!this.observer) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-entrance-in');
              this.observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
      }

      banners.forEach((el) => this.observer.observe(el));
    },
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.cart-drawer__panel');
      this.agreed = this.agreed === true;
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('submit', (event) => this.onCheckoutSubmit(event));
      this.syncCheckout();
      requestAnimationFrame(() => this.syncRecsNav());
      const row = this.querySelector('[data-recommendations-row]');
      if (row) {
        row.addEventListener('scroll', () => this.syncRecsNav(), { passive: true });
        bindDragScroll(row);
      }
    }

    get requiresAgreement() {
      return this.dataset.requireAgreement === 'true';
    }

    syncCheckout() {
      const checkbox = this.querySelector('[data-cart-agreement]');
      const button = this.querySelector('[data-checkout]');
      if (checkbox) checkbox.checked = this.agreed;
      if (!button) return;
      if (this._checkoutSubmitting) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        return;
      }
      const blocked = this.requiresAgreement && !this.agreed;
      button.disabled = blocked;
      button.setAttribute('aria-disabled', String(blocked));
    }

    onCheckoutSubmit(event) {
      if (event.target.closest('[data-cart-discount-form]')) return;
      if (!event.target.closest('[data-checkout-form]')) return;
      if (!this.requiresAgreement || this.agreed) {
        /* Guard duplicate submits from rapid clicks before navigation unloads. */
        if (this._checkoutSubmitting) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        this._checkoutSubmitting = true;
        const btn = this.querySelector('[data-checkout]');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      this.syncCheckout();
    }

    disconnectedCallback() {
      if (!this.isOpen) return;
      scrollLock.unlock();
      this.release?.();
      document.removeEventListener('keydown', this.onKeydown);
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    async onClick(event) {
      if (event.target.closest('[data-checkout]') && this.requiresAgreement && !this.agreed) {
        event.preventDefault();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        this.close();
        return;
      }

      const recsPrev = event.target.closest('[data-recs-prev]');
      const recsNext = event.target.closest('[data-recs-next]');
      if (recsPrev || recsNext) {
        event.preventDefault();
        this.scrollRecs(recsPrev ? -1 : 1);
        return;
      }

      const size = event.target.closest('[data-upsell-size], [data-quick-size]');
      if (size) {
        event.preventDefault();
        if (size.matches('[data-quick-size]')) {
          const root = size.closest('[data-quick-add-root]');
          root?.querySelectorAll('[data-quick-size]').forEach((btn) => {
            btn.setAttribute('aria-pressed', String(btn === size));
          });
          const addBtn = root?.querySelector('[data-quick-add]');
          if (addBtn) addBtn.dataset.variantId = size.dataset.variantId;

          if (root?.dataset.quickAddLayout === 'compact' && root?.hasAttribute('data-quick-add-expandable')) {
            const variantId = Number(size.dataset.variantId);
            if (!variantId) return;
            const trigger = addBtn || size;
            if (trigger.disabled || trigger.classList.contains('is-loading')) return;
            clearAddError(trigger);
            setAddLoading(trigger, true);
            try {
              await Cart.add(variantId, 1);
              await Cart.refresh();
              root.classList.remove('is-open');
              const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
              if (rail) rail.hidden = true;
              addBtn?.setAttribute('aria-expanded', 'false');
            } catch (error) {
              showAddError(trigger, error?.message || theme.strings.cartError);
            } finally {
              setAddLoading(trigger, false);
            }
          }
        } else {
          this.selectUpsellSize(size);
        }
        return;
      }

      const add = event.target.closest('[data-upsell-add], [data-quick-add]');
      if (add) {
        event.preventDefault();
        if (add.disabled || add.classList.contains('is-loading')) return;

        const root = add.closest('[data-quick-add-root]');
        if (
          add.matches('[data-quick-add]') &&
          root?.dataset.quickAddLayout === 'compact' &&
          root?.hasAttribute('data-quick-add-expandable')
        ) {
          const open = root.classList.toggle('is-open');
          const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
          if (rail) rail.hidden = !open;
          add.setAttribute('aria-expanded', String(open));
          return;
        }

        const variantId = Number(add.dataset.variantId);
        if (!variantId) return;
        clearAddError(add);
        setAddLoading(add, true);
        try {
          await Cart.add(variantId, 1);
          await Cart.refresh();
        } catch (error) {
          showAddError(add, error?.message || theme.strings.cartError);
        } finally {
          setAddLoading(add, false);
        }
        return;
      }

      const remove = event.target.closest('[data-remove-item]');
      const qty = event.target.closest('[data-quantity-change]');

      if (remove) {
        event.preventDefault();
        const variantId = String(remove.dataset.lineKey || '').split(':')[0];
        this.enqueueLineOp(async () => {
          try {
            const btn = this.findLineControl('[data-remove-item]', variantId);
            if (!btn) return;
            await Cart.change(btn.dataset.lineKey, 0);
            await Cart.refresh();
          } catch (error) {
            console.warn('[cart] remove failed', error);
          }
        });
        return;
      }

      if (qty) {
        event.preventDefault();
        const input = qty.parentElement?.querySelector('[data-quantity-input]');
        if (!input) return;
        const delta = Number(qty.dataset.quantityChange);
        const variantId = String(input.dataset.lineKey || '').split(':')[0];
        this.enqueueLineOp(async () => {
          try {
            const live = this.findLineControl('[data-quantity-input]', variantId);
            if (!live) return;
            const next = Math.max(1, Number(live.value) + delta);
            live.value = String(next);
            await Cart.change(live.dataset.lineKey, next);
            await Cart.refresh();
          } catch (error) {
            console.warn('[cart] quantity change failed', error);
          }
        });
      }
    }

    /* Serialize line mutations and re-resolve controls after each refresh.
       Discount applications can rotate Shopify line keys mid-flight. */
    enqueueLineOp(task) {
      this._lineChain = (this._lineChain || Promise.resolve())
        .catch(() => {})
        .then(task);
      return this._lineChain;
    }

    findLineControl(selector, variantId) {
      if (variantId) {
        const match = this.querySelector(`${selector}[data-line-key^="${variantId}:"]`);
        if (match) return match;
      }
      return this.querySelector(selector);
    }

    async onChange(event) {
      const agree = event.target.closest('[data-cart-agreement]');
      if (agree) {
        this.agreed = agree.checked;
        this.syncCheckout();
        return;
      }
      const input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      const variantId = String(input.dataset.lineKey || '').split(':')[0];
      const requested = Number(input.value);
      this.enqueueLineOp(async () => {
        try {
          const live = this.findLineControl('[data-quantity-input]', variantId);
          if (!live) return;
          const next = Number.isFinite(requested) ? requested : Number(live.value);
          await Cart.change(live.dataset.lineKey, next);
          await Cart.refresh();
        } catch (error) {
          console.warn('[cart] quantity input failed', error);
        }
      });
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      this.close();
    }

    open() {
      if (this.isOpen) return;
      /* Returning from checkout (bfcache/back) must re-arm the submit control. */
      this._checkoutSubmitting = false;
      /* Header overlays release the scroll lock before the drawer takes it. */
      document.dispatchEvent(new CustomEvent('theme:overlay:request', { detail: { source: this } }));
      this.lastFocused = document.activeElement;
      /* Lock scroll before paint so the scrollbar compensation lands with the open state. */
      scrollLock.lock();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document
        .querySelectorAll('[data-cart-open]')
        .forEach((el) => el.setAttribute('aria-expanded', 'true'));
      this.release = trapFocus(this.panel);
      document.addEventListener('keydown', this.onKeydown);
      this.panel?.focus({ preventScroll: true });
      bindDragScroll(this.querySelector('[data-drag-scroll]'));
      bindDragScroll(this.querySelector('[data-recommendations-row]'));
      this.syncRecsNav();
      this.syncCheckout();
      this.querySelectorAll('recently-viewed').forEach((el) => el.revealFromCart?.());
      /* Always resync from Shopify when opening so badge/API cannot diverge from drawer DOM. */
      Cart.refresh().catch(() => {
        Cart.get().then((cart) => this.updateFreeShipping(cart)).catch(() => {});
      });
      document.dispatchEvent(new CustomEvent('theme:overlay', { detail: { open: true, id: this.id } }));
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document
        .querySelectorAll('[data-cart-open]')
        .forEach((el) => el.setAttribute('aria-expanded', 'false'));
      scrollLock.unlock();
      this.release?.();
      document.removeEventListener('keydown', this.onKeydown);
      this.lastFocused?.focus();
      document.dispatchEvent(new CustomEvent('theme:overlay', { detail: { open: false, id: this.id } }));
    }

    selectUpsellSize(button) {
      const card = button.closest('[data-upsell-card]');
      if (!card) return;
      card.querySelectorAll('[data-upsell-size]').forEach((el) => {
        el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
      });
      const variantId = button.dataset.variantId;
      card.dataset.variantId = variantId;
      const add = card.querySelector('[data-upsell-add]');
      if (add) add.dataset.variantId = variantId;
      const price = card.querySelector('[data-upsell-price]');
      if (price && button.dataset.price) price.textContent = button.dataset.price;
    }

    scrollRecs(direction) {
      const row = this.querySelector('[data-recommendations-row]');
      if (!row) return;
      const card = row.querySelector('.cart-drawer__rec');
      const styles = getComputedStyle(row);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = card
        ? Math.round(card.getBoundingClientRect().width + gap)
        : Math.round(row.clientWidth * 0.7) || 160;
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      const target = Math.min(max, Math.max(0, Math.round(row.scrollLeft) + direction * distance));
      /* Absolute scrollTo avoids scroll-snap fighting scrollBy (esp. backward). */
      const prevSnap = row.style.scrollSnapType;
      row.style.scrollSnapType = 'none';
      row.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(() => {
        row.style.scrollSnapType = prevSnap;
        this.syncRecsNav();
      }, 320);
    }

    syncRecsNav() {
      const wrap = this.querySelector('.cart-drawer__recs');
      const row = this.querySelector('[data-recommendations-row]');
      if (!wrap || !row) return;
      const overflow = row.scrollWidth > row.clientWidth + 2;
      wrap.classList.toggle('has-overflow', overflow);
      const prev = wrap.querySelector('[data-recs-prev]');
      const next = wrap.querySelector('[data-recs-next]');
      const atStart = row.scrollLeft <= 2;
      const atEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      if (prev) {
        prev.disabled = !overflow || atStart;
        prev.setAttribute('aria-disabled', String(!overflow || atStart));
      }
      if (next) {
        next.disabled = !overflow || atEnd;
        next.setAttribute('aria-disabled', String(!overflow || atEnd));
      }
    }

    updateFreeShipping(cart) {
      if (this.dataset.freeShipping !== 'true' || !cart) return;

      const threshold = Number(this.dataset.freeShippingThreshold);
      if (!threshold || threshold <= 0) return;

      const bar = this.querySelector('[data-free-shipping-bar]');
      if (!bar) return;

      const subtotal = Number(cart.total_price) || 0;
      const remaining = Math.max(0, threshold - subtotal);
      const progress = Math.min(100, (subtotal / threshold) * 100);
      const unlocked = subtotal >= threshold;
      const progressRound = Math.round(progress);

      const textEl = bar.querySelector('[data-free-shipping-text]');
      if (textEl) {
        textEl.textContent = unlocked
          ? this.dataset.freeShippingSuccess || ''
          : formatFreeShippingMessage(this.dataset.freeShippingProgress, remaining);
      }

      const pctEl = bar.querySelector('[data-free-shipping-percent]');
      if (pctEl) pctEl.textContent = `${progressRound}%`;

      const track = bar.querySelector('.cart-free-shipping__track');
      if (track) track.setAttribute('aria-valuenow', String(progressRound));

      bar.dataset.progress = String(progressRound);
      bar.style.setProperty('--progress', `${progress}%`);
      bar.toggleAttribute('data-unlocked', unlocked);
      bar.classList.toggle('is-unlocked', unlocked);
    }
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      this.json = (() => {
        try {
          return JSON.parse(this.querySelector('[data-product-json]')?.textContent || '{}');
        } catch (error) {
          return {};
        }
      })();
      this.inventory = this.parseInventory();
      this.variantMedia = this.parseVariantMedia();
      this.variantInput = this.querySelector('[data-product-variant-id]');
      this.submit = this.querySelector('[data-add-to-cart]');
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
      this.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = this.querySelector('[data-quantity-input]');
          if (!input) return;
          input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange || 0));
        });
      });
      const initial = this.findVariant();
      this.syncPurchaseState(initial);
      this.syncMedia(initial);
    }

    parseInventory() {
      try {
        const rows = JSON.parse(this.querySelector('[data-variant-inventory]')?.textContent || '[]');
        return new Map((rows || []).map((row) => [Number(row.id), row]));
      } catch (error) {
        return new Map();
      }
    }

    parseVariantMedia() {
      try {
        const rows = JSON.parse(this.querySelector('[data-variant-media]')?.textContent || '[]');
        return new Map((rows || []).map((row) => [Number(row.id), row]));
      } catch (error) {
        return new Map();
      }
    }

    isVariantInStock(variant) {
      if (!variant) return false;
      const info = this.inventoryFor(variant);
      if (info?.managed) return Number(info.quantity) > 0;
      return Boolean(variant.available);
    }

    selectedOptions() {
      const names = Array.isArray(this.json.options) ? this.json.options : [];
      if (names.length) {
        return names.map((name) => {
          const safe = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(name)) : String(name).replace(/"/g, '\\"');
          const checked = this.querySelector(`input[data-option-value][name="${safe}"]:checked`);
          return checked?.value;
        });
      }
      return [...this.querySelectorAll('fieldset')].map((set) => {
        return set.querySelector('input[data-option-value]:checked')?.value;
      });
    }

    findVariant() {
      const options = this.selectedOptions();
      const variants = this.json.variants || [];
      if (!options.length || options.every((value) => value == null || value === '')) {
        const id = Number(this.variantInput?.value);
        return variants.find((variant) => variant.id === id) || variants[0];
      }
      return (
        variants.find((variant) =>
          (variant.options || []).every((option, index) => String(option) === String(options[index]))
        ) || null
      );
    }

    inventoryFor(variant) {
      if (!variant) return null;
      return this.inventory.get(Number(variant.id)) || {
        id: variant.id,
        available: Boolean(variant.available),
        quantity: Number(variant.inventory_quantity || 0),
        title: variant.title,
        sku: variant.sku,
        managed: variant.inventory_management
      };
    }

    renderAddLabel(variant) {
      const button = this.submit;
      if (!button) return;
      const text = button.querySelector('[data-add-text]');
      const priceEl = button.querySelector('[data-add-price]');
      const icon = button.querySelector('[data-add-icon]');
      const available = this.isVariantInStock(variant);

      if (!variant) {
        button.disabled = true;
        if (text) text.textContent = theme.strings.unavailable;
        if (priceEl) priceEl.hidden = true;
        if (icon) icon.hidden = true;
        return;
      }

      button.disabled = !available;
      const isPreorder = button.hasAttribute('data-preorder');
      if (text) text.textContent = available ? (isPreorder ? 'Pre-order' : theme.strings.addToCart) : theme.strings.soldOut;
      if (priceEl) {
        priceEl.hidden = !available;
        if (available) priceEl.textContent = money(variant.price);
      }
      if (icon) icon.hidden = !available;
    }

    syncInventory(variant) {
      const el = this.closest('.product')?.querySelector('[data-product-inventory]');
      if (el) {
        const info = this.inventoryFor(variant);
        if (!info?.managed) {
          el.textContent = '';
          el.hidden = true;
        } else {
          el.hidden = false;
          const threshold = Number(el.dataset.threshold || 5);
          const available = this.isVariantInStock(variant);
          if (!available || info.quantity <= 0) {
            el.textContent = el.dataset.labelOut || theme.strings.soldOut || 'Out of stock';
          } else if (info.quantity <= threshold) {
            el.textContent = (el.dataset.labelLow || 'Only [count] left').replace('[count]', String(info.quantity));
          } else {
            el.textContent = el.dataset.labelIn || 'In stock';
          }
        }
      }
      this.syncStockBadge(variant);
    }

    syncStockBadge(variant) {
      const root = this.closest('.product');
      if (!root) return;
      const el = root.querySelector('[data-product-stock]');
      if (!el) return;

      const info = this.inventoryFor(variant);
      const textEl = el.querySelector('[data-product-stock-text]');
      const dotEl = el.querySelector('[data-product-stock-dot]');
      const showDot = el.dataset.showDot !== 'false';
      const low = Number(el.dataset.low || 5);
      const high = Math.max(low, Number(el.dataset.high || 10));
      const tpl = el.dataset.text || 'Only {count} left';

      if (!info?.managed) {
        el.hidden = true;
        return;
      }

      const qty = Number(info.quantity || 0);
      const available = this.isVariantInStock(variant);
      if (!available || qty <= 0) {
        el.hidden = true;
        return;
      }

      el.hidden = false;
      let level = 'mid';
      if (qty > high) level = 'high';
      else if (qty <= low) level = 'low';

      el.classList.remove('product-stock--high', 'product-stock--mid', 'product-stock--low');
      el.classList.add(`product-stock--${level}`);

      if (textEl) {
        textEl.textContent = String(tpl).split('{count}').join(String(qty));
      }

      if (dotEl) {
        dotEl.hidden = !showDot;
        dotEl.classList.toggle('is-pulse', level === 'low' || level === 'high');
      }
    }

    syncSku(variant) {
      const el = this.closest('.product')?.querySelector('[data-product-sku]');
      if (!el) return;
      const sku = variant?.sku;
      if (!sku) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      const label = el.dataset.skuLabel || theme.strings.sku || 'SKU';
      el.textContent = `${label}: ${sku}`;
    }

    syncPurchaseState(variant) {
      const available = this.isVariantInStock(variant);

      this.renderAddLabel(variant);
      this.syncInventory(variant);
      this.syncSku(variant);

      if (this.submit) {
        if (!available) this.submit.disabled = true;
      }
    }

    onOptionChange() {
      const variant = this.findVariant();
      this.syncSelectedLabels();
      const price = this.closest('.product')?.querySelector('[data-product-price]');
      if (!variant) {
        if (this.variantInput) this.variantInput.value = '';
        this.syncPurchaseState(null);
        return;
      }
      if (this.variantInput) {
        this.variantInput.value = String(variant.id);
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) {
        const compare = variant.compare_at_price > variant.price
          ? `<span class="price__sale">${money(variant.price)}</span><s class="price__compare">${money(variant.compare_at_price)}</s>`
          : `<span class="price__regular">${money(variant.price)}</span>`;
        price.innerHTML = `<div class="price">${compare}</div>`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      this.syncMedia(variant);
      this.syncPurchaseState(variant);
    }

    syncSelectedLabels() {
      this.querySelectorAll('[data-option-swatches]').forEach((fieldset) => {
        const label = fieldset.querySelector('[data-option-selected]');
        const checked = fieldset.querySelector('input:checked');
        if (!label || !checked) return;
        label.textContent = checked.dataset.optionLabel || checked.value || '';
      });
    }

    syncMedia(variant) {
      if (!variant) return;
      const gallery = this.closest('.product')?.querySelector('media-gallery');
      if (!gallery) return;

      const mapped = this.variantMedia?.get(Number(variant.id));
      const mediaId =
        mapped?.mediaId ||
        variant.featured_media?.id ||
        variant.featured_image?.id ||
        variant.image_id ||
        null;
      const src =
        mapped?.src ||
        variant.featured_media?.preview_image?.src ||
        variant.featured_media?.src ||
        variant.featured_image?.src ||
        '';

      if (mediaId != null && typeof gallery.show === 'function') {
        if (gallery.show(String(mediaId))) return;
      }
      if (src && typeof gallery.showBySrc === 'function') {
        if (gallery.showBySrc(src)) return;
      }

      /* Last resort: match slide alt / filename to a color-like option value */
      const options = variant.options || [];
      const colorKeys = /^(color|colour|цвет|couleur|farbe|colore|kleur|cor)$/i;
      const optionNames = Array.isArray(this.json.options) ? this.json.options : [];
      let colorValue = '';
      optionNames.forEach((name, index) => {
        if (colorKeys.test(String(name || '').trim())) colorValue = options[index] || colorValue;
      });
      if (!colorValue && options.length) {
        /* Heuristic: longest non-size option often is color when names are custom */
        colorValue = options.find((opt, i) => !/^(size|sizes|размер)$/i.test(String(optionNames[i] || ''))) || '';
      }
      if (colorValue && typeof gallery.showByAlt === 'function') {
        gallery.showByAlt(colorValue);
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const variant = this.findVariant();
      if (!this.isVariantInStock(variant)) return;
      const id = Number(this.variantInput.value);
      const quantity = Number(this.querySelector('[data-quantity-input]')?.value || 1);
      if (!id || this.submit?.classList.contains('is-loading')) return;
      clearAddError(this.submit);
      setAddLoading(this.submit, true);
      try {
        await Cart.add(id, quantity);
        await Cart.refresh();
        Cart.open();
      } catch (error) {
        this.submit?.setAttribute('aria-invalid', 'true');
        showAddError(this.submit, error?.message || theme.strings.cartError);
      } finally {
        setAddLoading(this.submit, false);
        this.renderAddLabel(this.findVariant());
      }
    }
  }

  class ContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.submit = this.querySelector('[type="submit"]');
      this.nameInput = this.querySelector('[name="contact[name]"]');
      this.emailInput = this.querySelector('[name="contact[email]"]');
      this.bodyInput = this.querySelector('[name="contact[body]"]');
      this.onInput = this.sync.bind(this);
      this.form?.addEventListener('input', this.onInput);
      this.form?.addEventListener('change', this.onInput);
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.sync();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('input', this.onInput);
      this.form?.removeEventListener('change', this.onInput);
    }

    emailValid(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    isValid() {
      const name = this.nameInput?.value.trim();
      const email = this.emailInput?.value.trim();
      const body = this.bodyInput?.value.trim();
      return Boolean(name) && this.emailValid(email) && Boolean(body);
    }

    sync() {
      if (!this.submit) return;
      const valid = this.isValid();
      this.submit.disabled = !valid;
      this.submit.setAttribute('aria-disabled', String(!valid));
    }

    onSubmit(event) {
      this.sync();
      if (this.isValid()) return;
      event.preventDefault();
      event.stopPropagation();
    }
  }

  class CollectionSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.thumb = this.querySelector('[data-slider-progress]');
      this.items = [...this.querySelectorAll('.collection-list__item')];
      this.onScroll = this.update.bind(this);
      this.track?.addEventListener('scroll', this.onScroll, { passive: true });
      bindDragScroll(this.track);
      if (typeof ResizeObserver !== 'undefined' && this.track) {
        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.track);
      }
      this.update();
      requestAnimationFrame(() => {
        this.update();
        requestAnimationFrame(() => this.update());
      });
      if (window.MediaStates?.initAll) window.MediaStates.initAll(this);
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.ro?.disconnect();
    }

    update() {
      if (!this.track) return;
      this.items = [...this.querySelectorAll('.collection-list__item')];
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const overflow = maxScroll > 2;
      this.classList.toggle('has-overflow', overflow);
      this.classList.toggle('is-static', !overflow);

      if (!this.thumb) return;
      if (!overflow) {
        this.thumb.style.width = '100%';
        this.thumb.style.left = '0%';
        return;
      }

      const ratio = Math.min(1, Math.max(0, this.track.scrollLeft / maxScroll));
      const thumbRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
      const thumbWidth = Math.max(thumbRatio * 100, 8);
      const travel = 100 - thumbWidth;
      this.thumb.style.width = `${thumbWidth}%`;
      this.thumb.style.left = `${ratio * travel}%`;
    }
  }

  class FooterMenus extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(max-width: 749px)');
      this.onBreakpoint = this.sync.bind(this);
      this.onClick = this.onClick.bind(this);
      this.mq.addEventListener('change', this.onBreakpoint);
      this.addEventListener('click', this.onClick);
      this.sync();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.onBreakpoint);
    }

    get isAccordion() {
      return this.dataset.mobileStyle === 'accordion' && Boolean(this.mq?.matches);
    }

    setTrigger(button, expanded) {
      button.setAttribute('aria-expanded', String(expanded));
      const panel = button.closest('.footer__col')?.querySelector('[data-footer-panel]');
      if (panel) panel.setAttribute('aria-hidden', String(!expanded));
    }

    sync() {
      const accordion = this.isAccordion;
      this.classList.toggle('is-accordion', accordion);
      this.querySelectorAll('[data-footer-trigger]').forEach((button) => {
        if (!accordion) {
          this.setTrigger(button, true);
          button.setAttribute('tabindex', '-1');
          return;
        }
        button.setAttribute('tabindex', '0');
        if (button.dataset.ready !== 'true') {
          this.setTrigger(button, false);
          button.dataset.ready = 'true';
        }
      });
    }

    onClick(event) {
      const trigger = event.target.closest('[data-footer-trigger]');
      if (!trigger || !this.contains(trigger) || !this.isAccordion) return;
      event.preventDefault();
      const open = trigger.getAttribute('aria-expanded') === 'true';
      this.setTrigger(trigger, !open);
    }
  }

  class FooterWordmark extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-wordmark-text]');
      if (!this.text) return;
      this.fit = this.fit.bind(this);
      this._width = -1;
      this._fitRaf = 0;
      /* Observe the width-defining parent (<a.footer__wordmark>), not `this`.
         Schedule fit() on the next frame so fontSize writes are outside the
         ResizeObserver delivery cycle (avoids the undelivered-notifications loop). */
      this._roTarget = this.parentElement || this;
      this.ro?.disconnect();
      this.ro = new ResizeObserver(() => {
        if (this._fitRaf) return;
        this._fitRaf = requestAnimationFrame(() => {
          this._fitRaf = 0;
          this.fit();
        });
      });
      this.ro.observe(this._roTarget);
      if (document.fonts?.ready) document.fonts.ready.then(() => this.fit(true));
      this.fit(true);
    }

    disconnectedCallback() {
      if (this._fitRaf) {
        cancelAnimationFrame(this._fitRaf);
        this._fitRaf = 0;
      }
      this.ro?.disconnect();
      this.ro = null;
      this._roTarget = null;
    }

    fit(force) {
      const text = this.text;
      if (!text) return;
      const available = this.clientWidth;
      if (available <= 0) return;
      if (!force && available === this._width) return;
      this._width = available;

      /* Grow or shrink so the wordmark fills the row without overflowing. */
      let lo = 12;
      let hi = Math.min(Math.max(available * 0.42, 48), 520);
      for (let i = 0; i < 18; i += 1) {
        const mid = (lo + hi) / 2;
        text.style.fontSize = `${mid}px`;
        if (text.scrollWidth <= available * 0.995) lo = mid;
        else hi = mid;
      }
      const next = `${Math.max(12, lo)}px`;
      if (text.style.fontSize !== next) text.style.fontSize = next;
    }
  }

  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.onChange = () => this.form?.submit();
      this.onDocClick = this.onDocClick.bind(this);
      this.form?.addEventListener('change', this.onChange);
      this.querySelectorAll('[data-locale-picker]').forEach((picker) => this.bindPicker(picker));
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onDocClick);
    }

    bindPicker(picker) {
      const trigger = picker.querySelector('[data-locale-trigger]');
      const list = picker.querySelector('[data-locale-list]');
      const select = picker.querySelector('[data-locale-select]');
      const label = picker.querySelector('[data-locale-label]');
      if (!trigger || !list || !select) return;

      const options = [...list.querySelectorAll('[role="option"]')];

      const close = () => {
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
        picker.classList.remove('is-open');
      };

      const placeList = () => {
        list.style.left = '50%';
        list.style.right = 'auto';
        list.style.transform = 'translateX(-50%)';
        const rect = list.getBoundingClientRect();
        const pad = 12;
        let shift = 0;
        if (rect.left < pad) shift = pad - rect.left;
        if (rect.right > window.innerWidth - pad) shift = window.innerWidth - pad - rect.right;
        list.style.transform = `translateX(calc(-50% + ${shift}px))`;
      };

      const open = () => {
        trigger.setAttribute('aria-expanded', 'true');
        list.hidden = false;
        picker.classList.add('is-open');
        placeList();
        (list.querySelector('[aria-selected="true"]') || options[0])?.focus();
      };

      const choose = (option) => {
        if (!option) return;
        select.value = option.dataset.value;
        if (label) label.textContent = option.textContent.trim();
        options.forEach((el) => el.setAttribute('aria-selected', String(el === option)));
        close();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (trigger.getAttribute('aria-expanded') === 'true') close();
        else open();
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });

      options.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          choose(option);
        });
      });

      picker.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          trigger.focus();
          return;
        }
        if (list.hidden) return;
        const current = document.activeElement;
        const index = options.indexOf(current);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          options[(index + 1) % options.length]?.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          options[(index - 1 + options.length) % options.length]?.focus();
        } else if (event.key === 'Home') {
          event.preventDefault();
          options[0]?.focus();
        } else if (event.key === 'End') {
          event.preventDefault();
          options[options.length - 1]?.focus();
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(current?.closest('[role="option"]') || current);
        }
      });
    }

    onDocClick(event) {
      if (this.contains(event.target)) return;
      this.querySelectorAll('[data-locale-picker]').forEach((picker) => {
        picker.classList.remove('is-open');
        picker.querySelector('[data-locale-trigger]')?.setAttribute('aria-expanded', 'false');
        const list = picker.querySelector('[data-locale-list]');
        if (list) list.hidden = true;
      });
    }
  }

  class LaunchAbout extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.launch-about__panel');
      this.onKey = this.onKey.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.openers = [...document.querySelectorAll('[data-about-open]')];
      this.openers.forEach((btn) => btn.addEventListener('click', this.onToggle));
      this.querySelectorAll('[data-about-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      this.openers?.forEach((btn) => btn.removeEventListener('click', this.onToggle));
      this.release?.();
      if (this.classList.contains('is-open')) scrollLock.unlock();
    }

    onToggle(event) {
      event.preventDefault();
      this.open();
    }

    onKey(event) {
      if (event.key === 'Escape') this.close();
    }

    pauseMedia() {
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.querySelectorAll('iframe').forEach((frame) => {
        const src = frame.src;
        frame.src = src;
      });
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.hidden = false;
      this.classList.add('is-open');
      document.addEventListener('keydown', this.onKey);
      scrollLock.lock();
      this.release = trapFocus(this.panel);
      this.panel?.focus({ preventScroll: true });
    }

    close() {
      this.classList.remove('is-open');
      this.hidden = true;
      document.removeEventListener('keydown', this.onKey);
      this.release?.();
      this.pauseMedia();
      scrollLock.unlock();
      this.openers?.[0]?.focus();
    }
  }

  class LaunchCountdown extends HTMLElement {
    connectedCallback() {
      const endTs = Number(this.dataset.endTs || '');
      this.target = Number.isFinite(endTs) && endTs > 0 ? endTs * 1000 : Date.parse(this.dataset.end || '');
      this.values = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };
      this.units = this.querySelector('[data-units]');
      this.done = this.querySelector('[data-complete]');
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    tick() {
      if (!Number.isFinite(this.target)) return;

      const diff = this.target - Date.now();
      if (diff <= 0) {
        this.classList.add('is-complete');
        if (this.units) this.units.hidden = true;
        if (this.done) this.done.hidden = false;
        window.clearInterval(this.timer);
        return;
      }

      const total = Math.floor(diff / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      if (this.values.days) this.values.days.textContent = this.pad(days);
      if (this.values.hours) this.values.hours.textContent = this.pad(hours);
      if (this.values.minutes) this.values.minutes.textContent = this.pad(minutes);
      if (this.values.seconds) this.values.seconds.textContent = this.pad(seconds);
    }
  }

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-media-viewport]');
      this.track = this.querySelector('[data-media-track]');
      this.closeBtn = this.querySelector('[data-media-close]');
      this.glass = this.querySelector('[data-media-glass]');
      this.countEl = this.querySelector('[data-media-count]');
      this.viewModelBtn = this.querySelector('[data-view-model-toggle]');
      this.mediaSet = this.dataset.mediaSet || 'product';
      this.viewerOpen = false;
      this.moved = false;
      this.mq = window.matchMedia('(min-width: 750px)');
      this.hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.onBreakpoint = this.onBreakpoint.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onOverlay = this.onOverlay.bind(this);
      this.classList.add('is-ready');

      if (this.dataset.viewModel === 'true') {
        this.applyMediaSet(this.mediaSet || 'product', { instant: true, silent: true });
      } else {
        this.refreshVisibleMedia();
      }

      if (!this.slides.length) return;

      this.mq.addEventListener('change', this.onBreakpoint);
      this.hoverMq.addEventListener('change', this.onBreakpoint);
      this.bind();
      this.display(this.index, true);
    }

    disconnectedCallback() {
      this.closeViewer();
      this.unbind();
      this.mq?.removeEventListener('change', this.onBreakpoint);
      this.hoverMq?.removeEventListener('change', this.onBreakpoint);
    }

    get isDesktop() {
      return Boolean(this.mq?.matches);
    }

    get canHover() {
      return Boolean(this.hoverMq?.matches);
    }

    get transition() {
      return this.dataset.transition || 'fade';
    }

    get zoomMode() {
      return this.dataset.zoom || 'none';
    }

    get isScrollStack() {
      return false;
    }

    onBreakpoint() {
      if (!this.viewerOpen) {
        this.hideGlass();
      }
      this.bind();
      this.display(this.index, true);
    }

    bind() {
      this.unbind();

      this.prev = this.querySelector('[data-media-prev]');
      this.next = this.querySelector('[data-media-next]');
      this._onPrev = (event) => this.onNav(event, -1);
      this._onNext = (event) => this.onNav(event, 1);
      this.prev?.addEventListener('click', this._onPrev);
      this.next?.addEventListener('click', this._onNext);
      this._onClose = () => this.closeViewer();
      this.closeBtn?.addEventListener('click', this._onClose);

      if (this.viewModelBtn) {
        this._onViewModel = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMediaSet();
        };
        this.viewModelBtn.addEventListener('click', this._onViewModel);
      }

      this._onThumb = (event) => {
        const id = event.currentTarget.dataset.mediaId;
        if (id) this.show(id);
      };
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', this._onThumb));

      this._onDot = (event) => {
        const id = event.currentTarget.dataset.mediaId;
        if (id) this.show(id);
      };
      this.dots.forEach((dot) => dot.addEventListener('click', this._onDot));

      /* Thumbnail navigation (when more than 5 thumbnails) */
      this.thumbsPrev = this.querySelector('[data-thumbs-prev]');
      this.thumbsNext = this.querySelector('[data-thumbs-next]');
      this.thumbsList = this.querySelector('[data-media-thumbs]');
      if (this.thumbsPrev && this.thumbsNext && this.thumbsList) {
        this._onThumbsPrev = () => this.scrollThumbs(-1);
        this._onThumbsNext = () => this.scrollThumbs(1);
        this._onThumbsScroll = () => this.updateThumbsNav();
        this.thumbsPrev.addEventListener('click', this._onThumbsPrev);
        this.thumbsNext.addEventListener('click', this._onThumbsNext);
        this.thumbsList.addEventListener('scroll', this._onThumbsScroll, { passive: true });
        this.updateThumbsNav();
      }

      if (this.slides.length > 1 && !this.isScrollStack) {
        this._onPointer = (event) => this.onPointerDown(event);
        this.viewport?.addEventListener('pointerdown', this._onPointer);
      }

      if (this.zoomMode === 'viewer') {
        this._onActivate = (event) => this.onActivate(event);
        this.viewport?.addEventListener('click', this._onActivate);
      }

      if (this.zoomMode === 'glass' && this.canHover) {
        this._onGlassMove = (event) => this.onGlassMove(event);
        this._onGlassLeave = () => this.hideGlass();
        this.viewport?.addEventListener('pointermove', this._onGlassMove);
        this.viewport?.addEventListener('pointerleave', this._onGlassLeave);
      }

      /* Mobile / touch glass zoom: tap to open, drag to move, tap again to close */
      if (this.zoomMode === 'glass' && !this.canHover) {
        this.mobileGlassActive = false;
        this._onMobileGlassPointer = (event) => this.onMobileGlassPointerDown(event);
        this.viewport?.addEventListener('pointerdown', this._onMobileGlassPointer);
      }

      document.addEventListener('theme:overlay:request', this.onOverlay);
      this.setupScrollObserver();
    }

    unbind() {
      this.teardownScrollObserver();
      this.teardownMobileGlassDrag();
      this.prev?.removeEventListener('click', this._onPrev);
      this.next?.removeEventListener('click', this._onNext);
      this.closeBtn?.removeEventListener('click', this._onClose);
      this.viewModelBtn?.removeEventListener('click', this._onViewModel);
      this.thumbs.forEach((thumb) => thumb.removeEventListener('click', this._onThumb));
      this.dots.forEach((dot) => dot.removeEventListener('click', this._onDot));
      this.thumbsPrev?.removeEventListener('click', this._onThumbsPrev);
      this.thumbsNext?.removeEventListener('click', this._onThumbsNext);
      this.thumbsList?.removeEventListener('scroll', this._onThumbsScroll);
      this.viewport?.removeEventListener('pointerdown', this._onPointer);
      this.viewport?.removeEventListener('click', this._onActivate);
      this.viewport?.removeEventListener('pointermove', this._onGlassMove);
      this.viewport?.removeEventListener('pointerleave', this._onGlassLeave);
      this.viewport?.removeEventListener('pointerdown', this._onMobileGlassPointer);
      this.viewport?.removeEventListener('click', this._onMobileGlassTap);
      this.viewport?.removeEventListener('touchmove', this._onMobileGlassMove);
      this.viewport?.removeEventListener('touchend', this._onMobileGlassEnd);
      document.removeEventListener('theme:overlay:request', this.onOverlay);
      this.prev = null;
      this.next = null;
      this._onPrev = null;
      this._onNext = null;
      this._onClose = null;
      this._onViewModel = null;
      this._onThumb = null;
      this._onDot = null;
      this._onThumbsPrev = null;
      this._onThumbsNext = null;
      this._onThumbsScroll = null;
      this._onPointer = null;
      this._onActivate = null;
      this._onGlassMove = null;
      this._onMobileGlassPointer = null;
      this._onMobileGlassTap = null;
      this._onMobileGlassMove = null;
      this._onMobileGlassEnd = null;
      this._onGlassLeave = null;
    }

    refreshVisibleMedia() {
      const set = this.dataset.viewModel === 'true' ? this.mediaSet || 'product' : null;
      this.slides = [...this.querySelectorAll('.product-media__slide')].filter(
        (slide) => !slide.hidden && (!set || slide.dataset.mediaSet === set || !slide.dataset.mediaSet)
      );
      this.thumbs = [...this.querySelectorAll('[data-thumb]')].filter((thumb) => {
        const row = thumb.closest('li');
        if (row?.hidden) return false;
        if (!set) return true;
        return thumb.dataset.mediaSet === set || !thumb.dataset.mediaSet;
      });
      this.dots = [...this.querySelectorAll('[data-media-dot]')].filter((dot) => {
        if (dot.hidden) return false;
        if (!set) return true;
        return dot.dataset.mediaSet === set || !dot.dataset.mediaSet;
      });
      const active = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.index = active >= 0 ? active : 0;
      const nav = this.querySelector('[data-media-nav]');
      if (nav) nav.hidden = this.slides.length < 2;
    }

    toggleMediaSet() {
      if (this.dataset.viewModel !== 'true') return;
      const next = this.mediaSet === 'model' ? 'product' : 'model';
      this.applyMediaSet(next);
    }

    applyMediaSet(setName, options = {}) {
      if (this.dataset.viewModel !== 'true') {
        this.refreshVisibleMedia();
        return;
      }
      const set = setName === 'model' ? 'model' : 'product';
      this.mediaSet = set;
      this.dataset.mediaSet = set;

      this.querySelectorAll('.product-media__slide[data-media-set]').forEach((slide) => {
        const match = slide.dataset.mediaSet === set;
        slide.hidden = !match;
        if (!match) slide.classList.remove('is-active');
      });
      this.querySelectorAll('[data-media-thumbs] li[data-media-set]').forEach((row) => {
        row.hidden = row.dataset.mediaSet !== set;
      });
      this.querySelectorAll('[data-media-dot][data-media-set]').forEach((dot) => {
        dot.hidden = dot.dataset.mediaSet !== set;
      });

      this.refreshVisibleMedia();
      this.syncViewModelControl();

      let nextIndex = 0;
      if (options.keepId) {
        const found = this.slides.findIndex(
          (slide) =>
            slide.dataset.mediaId === String(options.keepId) ||
            slide.dataset.imageId === String(options.keepId) ||
            slide.dataset.previewId === String(options.keepId)
        );
        if (found >= 0) nextIndex = found;
      }

      this.hideGlass();
      if (!options.silent) this.bind();
      if (this.slides.length) this.display(nextIndex, options.instant !== false);
    }

    syncViewModelControl() {
      const btn = this.viewModelBtn;
      if (!btn) return;
      const on = this.mediaSet === 'model';
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute(
        'aria-label',
        on
          ? btn.dataset.labelHide || 'Show product photos'
          : btn.dataset.labelShow || 'Show model photos'
      );
      const iconOff = btn.querySelector('.product-media__view-model-icon--off');
      const iconOn = btn.querySelector('.product-media__view-model-icon--on');
      if (iconOff) iconOff.hidden = on;
      if (iconOn) iconOn.hidden = !on;
    }

    setupScrollObserver() {
      this.teardownScrollObserver();
      if (!this.isScrollStack || this.slides.length < 2 || !this.viewport) return;

      this._io = new IntersectionObserver(
        (entries) => {
          let best = null;
          let bestRatio = 0;
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= bestRatio) {
              bestRatio = entry.intersectionRatio;
              best = entry.target;
            }
          });
          if (!best || bestRatio < 0.6) return;
          const index = this.slides.indexOf(best);
          if (index < 0 || index === this.index) return;
          this._fromScrollObserve = true;
          this.display(index, true);
          this._fromScrollObserve = false;
        },
        /* Document is the scroller for stack mode (no nested gallery scrollbar). */
        { root: null, threshold: [0.55, 0.75, 1], rootMargin: '-12% 0px -35% 0px' }
      );
      this.slides.forEach((slide) => this._io.observe(slide));
    }

    teardownScrollObserver() {
      this._io?.disconnect();
      this._io = null;
    }

    scrollToSlide(index, instant) {
      const slide = this.slides[index];
      if (!slide) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slide.scrollIntoView({
        block: 'nearest',
        behavior: instant || reduce ? 'auto' : 'smooth',
      });
    }

    onOverlay(event) {
      if (event.detail?.source === this) return;
      this.closeViewer();
    }

    onNav(event, step) {
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget?.blur();
      this.go(this.index + step);
    }

    onActivate(event) {
      if (this.viewerOpen || this.moved) return;
      if (this.zoomMode !== 'viewer') return;
      if (event.target.closest('[data-media-nav], [data-media-close], video, iframe, model-viewer, button, a')) return;
      if (this.isScrollStack) {
        const slide = event.target.closest('.product-media__slide');
        if (slide) {
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.index = index;
        }
      }
      const slide = this.slides[this.index];
      if (!slide || slide.dataset.mediaType !== 'image') return;
      this.openViewer();
    }

    onPointerDown(event) {
      if (this.mobileGlassActive) return;
      if (event.pointerType === 'mouse' && this.isDesktop && !this.viewerOpen) return;
      if (event.target.closest('[data-media-nav], [data-media-close], [data-media-thumbs], [data-media-dots], video, iframe, model-viewer, button')) return;

      const startX = event.clientX;
      const startY = event.clientY;
      this.moved = false;
      let axis = null;

      const point = (moveEvent) => {
        const touch = moveEvent.touches && moveEvent.touches[0];
        return {
          x: touch ? touch.clientX : moveEvent.clientX,
          y: touch ? touch.clientY : moveEvent.clientY
        };
      };

      const onMove = (moveEvent) => {
        const { x, y } = point(moveEvent);
        const dx = x - startX;
        const dy = y - startY;
        if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        }
        if (axis === 'x') {
          this.moved = Math.abs(dx) > 24;
          if (moveEvent.cancelable) moveEvent.preventDefault();
        }
      };

      const onUp = (upEvent) => {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('touchmove', onMove);
        const end = point(upEvent);
        const dx = end.x - startX;
        if (axis !== 'x' || Math.abs(dx) < 40) return;
        if (upEvent.cancelable) upEvent.preventDefault();
        this.go(this.index + (dx < 0 ? 1 : -1));
      };

      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp, { once: true });

      this.viewport?.addEventListener(
        'click',
        (clickEvent) => {
          if (!this.moved) return;
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        },
        { capture: true, once: true }
      );
    }

    glassZoomSrc(img) {
      if (img?.dataset?.zoomSrc) return img.dataset.zoomSrc;
      const srcset = img?.getAttribute?.('srcset');
      if (srcset) {
        const last = srcset
          .split(',')
          .map((part) => part.trim().split(/\s+/)[0])
          .filter(Boolean)
          .pop();
        if (last) return last;
      }
      return img?.currentSrc || img?.src || '';
    }

    objectPositionOffset(token, box, rendered) {
      if (!token || token === 'center') return (box - rendered) / 2;
      if (token === 'left' || token === 'top') return 0;
      if (token === 'right' || token === 'bottom') return box - rendered;
      if (token.endsWith('%')) return (box - rendered) * (parseFloat(token) / 100);
      const px = parseFloat(token);
      return Number.isFinite(px) ? px : (box - rendered) / 2;
    }

    renderedImageMetrics(img) {
      const rect = img.getBoundingClientRect();
      const nw = img.naturalWidth || 0;
      const nh = img.naturalHeight || 0;
      if (!nw || !nh || rect.width < 1 || rect.height < 1) {
        return { rect, renderedW: rect.width, renderedH: rect.height, offsetX: 0, offsetY: 0, nw, nh };
      }

      const style = getComputedStyle(img);
      const fit = style.objectFit || 'fill';
      let scale = 1;
      if (fit === 'contain') scale = Math.min(rect.width / nw, rect.height / nh);
      else if (fit === 'cover') scale = Math.max(rect.width / nw, rect.height / nh);
      else if (fit === 'none') scale = 1;
      else if (fit === 'scale-down') scale = Math.min(1, Math.min(rect.width / nw, rect.height / nh));
      else {
        return { rect, renderedW: rect.width, renderedH: rect.height, offsetX: 0, offsetY: 0, nw, nh };
      }

      const renderedW = nw * scale;
      const renderedH = nh * scale;
      const parts = String(style.objectPosition || '50% 50%').trim().split(/\s+/);
      return {
        rect,
        renderedW,
        renderedH,
        offsetX: this.objectPositionOffset(parts[0], rect.width, renderedW),
        offsetY: this.objectPositionOffset(parts[1] || '50%', rect.height, renderedH),
        nw,
        nh
      };
    }

    paintGlass(img, clientX, clientY, options = {}) {
      if (!img || !this.glass || !this.viewport) return false;

      const view = this.viewport.getBoundingClientRect();
      const { rect, renderedW, renderedH, offsetX, offsetY } = this.renderedImageMetrics(img);
      let imageX = clientX - rect.left - offsetX;
      let imageY = clientY - rect.top - offsetY;

      if (options.clamp) {
        imageX = Math.max(0, Math.min(imageX, renderedW));
        imageY = Math.max(0, Math.min(imageY, renderedH));
      } else if (imageX < 0 || imageY < 0 || imageX > renderedW || imageY > renderedH) {
        return false;
      }

      const src = this.glassZoomSrc(img);
      if (!src) return false;

      this.glass.hidden = false;
      const glassW = this.glass.offsetWidth || 136;
      const glassH = this.glass.offsetHeight || 136;
      const zoom = Math.min(8, Math.max(2, parseFloat(this.dataset.glassZoom) || 4));

      let lensX = clientX - view.left;
      let lensY = clientY - view.top;
      if (options.clamp) {
        lensX = Math.max(rect.left, Math.min(clientX, rect.right)) - view.left;
        lensY = Math.max(rect.top, Math.min(clientY, rect.bottom)) - view.top;
      }

      this.glass.style.backgroundImage = `url("${src}")`;
      this.glass.style.backgroundSize = `${renderedW * zoom}px ${renderedH * zoom}px`;
      this.glass.style.backgroundPosition = `${-(imageX * zoom - glassW / 2)}px ${-(imageY * zoom - glassH / 2)}px`;
      this.glass.style.left = `${lensX}px`;
      this.glass.style.top = `${lensY}px`;
      return true;
    }

    onGlassMove(event) {
      if (!this.canHover || this.viewerOpen || this.zoomMode !== 'glass') {
        this.hideGlass();
        return;
      }
      if (event.target.closest('[data-media-nav], [data-media-close], [data-view-model-toggle], button, a, video, iframe, model-viewer')) {
        this.hideGlass();
        return;
      }
      
      /* Find which slide the mouse is currently over (for scroll stack mode) */
      let targetSlide = this.slides[this.index];
      const hoverSlide = event.target.closest('.product-media__slide');
      if (hoverSlide && this.slides.includes(hoverSlide)) {
        targetSlide = hoverSlide;
      }
      
      const img = targetSlide?.dataset.mediaType === 'image' ? targetSlide.querySelector('img') : null;
      if (!this.paintGlass(img, event.clientX, event.clientY)) {
        this.hideGlass();
      }
    }

    hideGlass() {
      if (!this.glass) return;
      this.glass.hidden = true;
      this.glass.classList.remove('is-mobile-active');
      this.glass.style.backgroundImage = '';
      this.classList.remove('is-mobile-glass');
      this.mobileGlassActive = false;
      this.mobileGlassSlide = null;
    }

    /* Thumbnail navigation */
    thumbsAreVertical() {
      if (this.viewerOpen && !this.isDesktop) return false;
      return this.thumbsList?.closest('.product-media__thumbs-wrap')?.dataset.thumbDirection === 'vertical';
    }

    scrollThumbs(direction) {
      if (!this.thumbsList) return;
      const isVertical = this.thumbsAreVertical();
      const thumbSize = this.thumbs[0]?.offsetWidth || 68;
      const gap = 8;
      const scrollAmount = (thumbSize + gap) * 2;
      
      if (isVertical) {
        this.thumbsList.scrollBy({ top: direction * scrollAmount, behavior: 'smooth' });
      } else {
        this.thumbsList.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
      }
    }

    updateThumbsNav() {
      if (!this.thumbsList || !this.thumbsPrev || !this.thumbsNext) return;
      const isVertical = this.thumbsAreVertical();
      
      if (isVertical) {
        const { scrollTop, scrollHeight, clientHeight } = this.thumbsList;
        this.thumbsPrev.disabled = scrollTop <= 0;
        this.thumbsNext.disabled = scrollTop + clientHeight >= scrollHeight - 1;
      } else {
        const { scrollLeft, scrollWidth, clientWidth } = this.thumbsList;
        this.thumbsPrev.disabled = scrollLeft <= 0;
        this.thumbsNext.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    /* Mobile glass zoom — tap to open, drag to inspect, tap again to close */
    onMobileGlassPointerDown(event) {
      if (this.viewerOpen || this.zoomMode !== 'glass') return;
      if (event.pointerType === 'mouse' && this.canHover) return;
      if (event.target.closest('[data-media-nav], [data-media-close], [data-media-thumbs], [data-media-dots], button, a, video, iframe, model-viewer')) {
        return;
      }

      const slide = event.target.closest('.product-media__slide[data-media-type="image"]');
      if (!slide) {
        this.deactivateMobileGlass();
        return;
      }

      const startX = event.clientX;
      const startY = event.clientY;
      let dragged = false;
      const pointerId = event.pointerId;
      const wasActive = this.mobileGlassActive;

      this.teardownMobileGlassDrag();
      this._glassPointerId = pointerId;

      if (wasActive) {
        this.mobileGlassSlide = slide;
        this.showMobileGlass(slide, startX, startY);
      }

      this._onGlassDragMove = (moveEvent) => {
        if (moveEvent.pointerId !== pointerId) return;
        const dx = moveEvent.clientX - startX;
        const dy = moveEvent.clientY - startY;
        if (Math.hypot(dx, dy) > 8) dragged = true;
        if (!wasActive) return;
        if (moveEvent.cancelable) moveEvent.preventDefault();
        this.showMobileGlass(this.mobileGlassSlide || slide, moveEvent.clientX, moveEvent.clientY);
      };

      this._onGlassDragUp = (upEvent) => {
        if (upEvent.pointerId !== pointerId) return;
        this.teardownMobileGlassDrag();

        if (!wasActive) {
          /* First tap (no drag) opens the lens — swipe gestures are ignored */
          if (!dragged) this.activateMobileGlass(slide, startX, startY);
          return;
        }

        /* Already open: tap without drag closes; drag just moves */
        if (!dragged) this.deactivateMobileGlass();
      };

      window.addEventListener('pointermove', this._onGlassDragMove, { passive: false });
      window.addEventListener('pointerup', this._onGlassDragUp);
      window.addEventListener('pointercancel', this._onGlassDragUp);
    }

    activateMobileGlass(slide, clientX, clientY) {
      this.mobileGlassActive = true;
      this.mobileGlassSlide = slide;
      this.classList.add('is-mobile-glass');
      this.glass?.classList.add('is-mobile-active');
      this.showMobileGlass(slide, clientX, clientY);
    }

    deactivateMobileGlass() {
      this.mobileGlassActive = false;
      this.mobileGlassSlide = null;
      this.classList.remove('is-mobile-glass');
      this.glass?.classList.remove('is-mobile-active');
      this.hideGlass();
      this.teardownMobileGlassDrag();
    }

    teardownMobileGlassDrag() {
      if (this._onGlassDragMove) {
        window.removeEventListener('pointermove', this._onGlassDragMove);
        this._onGlassDragMove = null;
      }
      if (this._onGlassDragUp) {
        window.removeEventListener('pointerup', this._onGlassDragUp);
        window.removeEventListener('pointercancel', this._onGlassDragUp);
        this._onGlassDragUp = null;
      }
      this._glassPointerId = null;
    }

    showMobileGlass(slide, clientX, clientY) {
      const img = slide?.querySelector('img');
      if (!this.paintGlass(img, clientX, clientY, { clamp: true })) return;
      this.glass.classList.add('is-mobile-active');
    }

    onKey(event) {
      if (!this.viewerOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeViewer();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.go(this.index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.go(this.index + 1);
      }
    }

    openViewer() {
      if (this.viewerOpen || this.zoomMode !== 'viewer') return;
      this.hideGlass();
      this.teardownScrollObserver();
      const host = this.parentElement;
      if (host) host.style.minHeight = `${this.offsetHeight}px`;
      document.body.classList.add('has-media-viewer');
      this.viewerOpen = true;
      this.classList.add('is-viewer');
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      if (this.closeBtn) this.closeBtn.hidden = false;
      this.closeBtn?.focus({ preventScroll: true });
      scrollLock.lock();
      this.releaseFocus = trapFocus(this);
      document.addEventListener('keydown', this.onKey);
      this.dispatchEvent(new CustomEvent('theme:overlay:request', { bubbles: true, detail: { source: this } }));
      this.bind();
      this.display(this.index, true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-viewer-ready'));
      });
    }

    closeViewer() {
      if (!this.viewerOpen) return;
      this.viewerOpen = false;
      this.classList.remove('is-viewer-ready');
      this.classList.remove('is-viewer');
      this.removeAttribute('role');
      this.removeAttribute('aria-modal');
      if (this.closeBtn) this.closeBtn.hidden = true;
      const host = this.parentElement;
      if (host) host.style.minHeight = '';
      document.body.classList.remove('has-media-viewer');
      this.releaseFocus?.();
      this.releaseFocus = null;
      document.removeEventListener('keydown', this.onKey);
      scrollLock.unlock();
      this.bind();
      this.display(this.index, true);
    }

    pauseInactive() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.querySelectorAll('video').forEach((video) => {
          try {
            video.muted = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.removeAttribute('controls');
            video.controls = false;
            if (active) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          } catch (error) {
            /* Ignore media errors. */
          }
        });
      });
    }

    display(index, instant) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      const current = ((index % count) + count) % count;
      this.index = current;

      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      this.syncNaturalRatio(current);
      const activeId = this.slides[current]?.dataset.mediaId;
      this.thumbs.forEach((thumb) => {
        const active = Boolean(activeId) && thumb.dataset.mediaId === activeId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
      });
      this.dots.forEach((dot) => {
        const active = Boolean(activeId) && dot.dataset.mediaId === activeId;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (this.countEl) {
        this.countEl.textContent = `${current + 1} / ${count}`;
      }

      if (this.isScrollStack) {
        if (this.track) {
          this.track.style.transitionDuration = '';
          this.track.style.transform = '';
        }
        if (!this._fromScrollObserve) {
          this.scrollToSlide(current, instant);
        }
      } else if (this.track && this.transition === 'slide') {
        this.track.style.transitionDuration = instant ? '0ms' : '';
        this.track.style.transform = `translateX(-${current * 100}%)`;
      } else if (this.track) {
        this.track.style.transitionDuration = '';
        this.track.style.transform = '';
      }

      this.pauseInactive();
      this.hideGlass();
      this.scrollThumbIntoView();
    }

    syncNaturalRatio(index) {
      if (this.dataset.ratio !== 'natural' || this.viewerOpen) return;
      const slide = this.slides[index];
      if (!slide) return;
      let ratio = parseFloat(slide.dataset.aspect);
      const img = slide.querySelector('img');
      if (img?.naturalWidth && img.naturalHeight) {
        ratio = img.naturalWidth / img.naturalHeight;
      } else {
        const video = slide.querySelector('video');
        if (video?.videoWidth && video.videoHeight) {
          ratio = video.videoWidth / video.videoHeight;
        }
      }
      if (!ratio || !Number.isFinite(ratio) || ratio <= 0) return;
      this.style.setProperty('--media-ratio', `${ratio} / 1`);
    }

    scrollThumbIntoView() {
      const active = this.thumbs[this.index];
      const scroller = this.querySelector('[data-media-thumbs]');
      if (!active || !scroller) return;
      const sRect = scroller.getBoundingClientRect();
      const tRect = active.getBoundingClientRect();
      if (scroller.scrollWidth > scroller.clientWidth + 1) {
        scroller.scrollLeft += tRect.left - sRect.left - (sRect.width - tRect.width) / 2;
      } else if (scroller.scrollHeight > scroller.clientHeight + 1) {
        scroller.scrollTop += tRect.top - sRect.top - (sRect.height - tRect.height) / 2;
      }
    }

    go(next, instant) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      this.display(((next % count) + count) % count, instant);
    }

    show(id) {
      this.refreshVisibleMedia();
      const needle = String(id);
      const matchSlide = (slide) =>
        slide.dataset.mediaId === needle ||
        slide.dataset.imageId === needle ||
        slide.dataset.previewId === needle;

      let index = this.slides.findIndex(matchSlide);
      if (index >= 0) {
        this.go(index);
        return true;
      }

      if (this.dataset.viewModel === 'true') {
        const all = [...this.querySelectorAll('.product-media__slide')];
        const slide = all.find(matchSlide);
        if (slide?.dataset.mediaSet) {
          this.applyMediaSet(slide.dataset.mediaSet, { keepId: id, instant: true });
          return this.slides.some(matchSlide);
        }
      }
      return false;
    }

    showBySrc(src) {
      if (!src) return false;
      this.refreshVisibleMedia();
      const bare = String(src).split('?')[0].replace(/^https?:/, '');
      const matchSlide = (slide) => {
        const img = slide.querySelector('img');
        if (!img) return false;
        const hay = (img.currentSrc || img.src || img.getAttribute('src') || '').split('?')[0].replace(/^https?:/, '');
        if (!hay) return false;
        return hay === bare || hay.endsWith(bare) || bare.endsWith(hay) || hay.includes(bare) || bare.includes(hay);
      };

      let index = this.slides.findIndex(matchSlide);
      if (index >= 0) {
        this.go(index);
        return true;
      }

      if (this.dataset.viewModel === 'true') {
        const all = [...this.querySelectorAll('.product-media__slide')];
        const slide = all.find(matchSlide);
        if (slide?.dataset.mediaSet) {
          this.applyMediaSet(slide.dataset.mediaSet, {
            keepId: slide.dataset.mediaId,
            instant: true
          });
          return this.slides.some(matchSlide);
        }
      }
      return false;
    }

    showByAlt(value) {
      if (!value) return false;
      this.refreshVisibleMedia();
      const needle = String(value).toLowerCase().trim();
      if (!needle) return false;
      const matchSlide = (slide) => {
        const img = slide.querySelector('img');
        const alt = String(img?.getAttribute('alt') || img?.alt || '').toLowerCase();
        const src = String(img?.currentSrc || img?.src || '').toLowerCase();
        return alt.includes(needle) || src.includes(needle.replace(/\s+/g, '-')) || src.includes(needle.replace(/\s+/g, '_'));
      };

      let index = this.slides.findIndex(matchSlide);
      if (index >= 0) {
        this.go(index);
        return true;
      }

      if (this.dataset.viewModel === 'true') {
        const all = [...this.querySelectorAll('.product-media__slide')];
        const slide = all.find(matchSlide);
        if (slide?.dataset.mediaSet) {
          this.applyMediaSet(slide.dataset.mediaSet, {
            keepId: slide.dataset.mediaId,
            instant: true
          });
          return this.slides.some(matchSlide);
        }
      }
      return false;
    }
  }

  class SizeChart extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-size-chart-open]');
      this.modal = this.querySelector('[data-size-chart-modal]');
      if (!this.trigger || !this.modal) return;
      this.onKey = this.onKey.bind(this);
      this.trigger.addEventListener('click', this._onOpen = (event) => {
        event.preventDefault();
        this.open();
      });
      this.modal.addEventListener('click', this._onClick = (event) => {
        if (event.target.closest('[data-size-chart-close]')) this.close();
      });
      document.addEventListener('theme:overlay:request', this._onOverlay = (event) => {
        if (event.detail?.source === this) return;
        this.close();
      });
    }

    disconnectedCallback() {
      this.close();
      this.trigger?.removeEventListener('click', this._onOpen);
      this.modal?.removeEventListener('click', this._onClick);
      document.removeEventListener('theme:overlay:request', this._onOverlay);
    }

    onKey(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }

    open() {
      if (!this.modal) return;
      if (this.modal.classList.contains('is-open')) return;
      this.modal.hidden = false;
      this.modal.classList.remove('is-open');
      void this.modal.offsetWidth;
      this.modal.classList.add('is-open');
      scrollLock.lock();
      this.releaseFocus = trapFocus(this.modal);
      document.addEventListener('keydown', this.onKey);
      this.modal.querySelector('[data-size-chart-close]')?.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('theme:overlay:request', { bubbles: true, detail: { source: this } }));
    }

    close() {
      if (!this.modal || !this.modal.classList.contains('is-open')) return;
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      this.releaseFocus?.();
      this.releaseFocus = null;
      document.removeEventListener('keydown', this.onKey);
      scrollLock.unlock();
      this.trigger?.focus({ preventScroll: true });
    }
  }

  class ProductAccordion extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-accordion-trigger]');
      this.panel = this.querySelector('[data-accordion-panel]');
      if (!this.trigger) return;
      this.trigger.addEventListener('click', this._onClick = () => this.toggle());
      this.sync(false, true);
      if (this.dataset.open === 'true') {
        window.requestAnimationFrame(() => {
          const first = this.closest('.product')?.querySelector('product-accordion[data-open="true"]') || this;
          if (first === this) this.open(true);
        });
      }
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this._onClick);
    }

    toggle() {
      if (this.classList.contains('is-open')) this.close();
      else this.open();
    }

    open(instant) {
      this.closest('.product')?.querySelectorAll('product-accordion.is-open').forEach((item) => {
        if (item !== this) item.close(instant);
      });
      this.sync(true, instant);
    }

    close(instant) {
      this.sync(false, instant);
    }

    sync(open, instant) {
      this.classList.toggle('is-open', open);
      this.trigger?.setAttribute('aria-expanded', String(open));
      if (this.panel) this.panel.inert = !open;
      if (instant && this.panel) {
        this.panel.style.transition = 'none';
        void this.panel.offsetHeight;
        this.panel.style.transition = '';
      }
    }
  }

  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!this.tabs.length) return;
      this._onClick = (event) => {
        const tab = event.target.closest?.('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.select(this.tabs.indexOf(tab));
      };
      this._onKey = (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current < 0) return;
        let next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next]?.focus();
      };
      this.addEventListener('click', this._onClick);
      this.list.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.list?.removeEventListener('keydown', this._onKey);
    }

    select(index) {
      if (index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.classList.toggle('is-active', selected);
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.panels[i];
        if (panel) panel.hidden = !selected;
      });
    }
  }

  let collectionGridPrefs = { desktop: null, mobile: null };
  try {
    collectionGridPrefs.desktop = sessionStorage.getItem('wv:grid-desktop');
    collectionGridPrefs.mobile = sessionStorage.getItem('wv:grid-mobile');
  } catch (error) {
    /* Private mode. */
  }

  class CollectionGrid extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-filter-form]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.sortRoot = this.querySelector('[data-sort]');
      this.sortToggle = this.querySelector('[data-sort-toggle]');
      this.sortMenu = this.querySelector('[data-sort-menu]');
      this.grid = this.querySelector('[data-product-grid]');
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filters = this.querySelector('#CollectionFilters');
      this.filterDrawer = this.querySelector('[data-filter-drawer]');
      this.filterPanel = this.filterDrawer?.querySelector('[data-filter-panel]');
      this.stock = this.querySelector('[data-in-stock]');
      this.nav = this.querySelector('[data-collection-nav-wrap]');
      this.navScroller = this.querySelector('[data-collection-nav]');
      this.sizeFilter = this.querySelector('[data-size-filter]');
      this.sizeScroller = this.querySelector('[data-size-scroll]');
      this.colorFilter = this.querySelector('[data-color-filter]');
      this.colorScroller = this.querySelector('[data-color-scroll]');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.syncFades = this.syncFades.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.querySelectorAll('[data-filter-form]').forEach((form) => {
        form.addEventListener('change', () => {
          if (this.filterDrawer?.classList.contains('is-open')) return;
          this.apply();
        });
      });
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);

      let desktop = collectionGridPrefs.desktop || this.dataset.gridDesktop;
      let mobile = collectionGridPrefs.mobile || this.dataset.gridMobile;
      if (desktop === '2') desktop = '3';
      if (desktop) this.setGrid('desktop', desktop, false);
      if (mobile) this.setGrid('mobile', mobile, false);

      if (this.navScroller) {
        bindDragScroll(this.navScroller);
        this.navScroller.addEventListener('scroll', this.syncFades, { passive: true });
      }
      if (this.sizeScroller) {
        bindDragScroll(this.sizeScroller);
        this.sizeScroller.addEventListener('scroll', this.syncFades, { passive: true });
      }
      if (this.colorScroller) {
        bindDragScroll(this.colorScroller);
        this.colorScroller.addEventListener('scroll', this.syncFades, { passive: true });
      }
      window.addEventListener('resize', this.syncFades);
      this.syncFades();

      this.hydrateSizeFromUrl();
      this.hydrateColorFromUrl();
      this.bindPriceRange();
      this.syncProductVisibility();
    }

    disconnectedCallback() {
      this._abort?.abort();
      this.closeFilterDrawer({ silent: true });
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.syncFades);
      this.navScroller?.removeEventListener('scroll', this.syncFades);
      this.sizeScroller?.removeEventListener('scroll', this.syncFades);
      this.colorScroller?.removeEventListener('scroll', this.syncFades);
    }

    isMobileFilter() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    filterForm() {
      if (this.isMobileFilter()) {
        return this.filterDrawer?.querySelector('[data-filter-form]') || this.form;
      }
      return this.form;
    }

    onChange(event) {
      const sizeInput = event.target.closest('[data-size-filter] input[data-size-value]');
      if (sizeInput) {
        this.syncSizeValue(sizeInput.getAttribute('data-size-value'), sizeInput.checked);
        if (!this.filterDrawer?.classList.contains('is-open')) this.apply();
      }
    }

    syncSizeValue(value, pressed) {
      this.querySelectorAll('[data-size-filter] [data-size-value]').forEach((el) => {
        if (el.getAttribute('data-size-value') !== value) return;
        if (el.matches('input')) el.checked = pressed;
        else el.setAttribute('aria-pressed', String(pressed));
      });
    }

    parsePriceMajor(raw) {
      if (raw == null) return null;
      const text = String(raw).trim().replace(/\s/g, '');
      if (!text) return null;
      let normalized = text;
      if (text.includes(',') && text.includes('.')) {
        normalized = text.lastIndexOf(',') > text.lastIndexOf('.')
          ? text.replace(/\./g, '').replace(',', '.')
          : text.replace(/,/g, '');
      } else if (text.includes(',')) {
        normalized = text.replace(',', '.');
      }
      const value = Number(normalized);
      return Number.isFinite(value) ? value : null;
    }

    majorFromCents(cents) {
      const amount = Number(cents) / 100;
      if (!Number.isFinite(amount)) return '';
      return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    }

    activePriceRange() {
      if (this.isMobileFilter()) {
        return this.filterDrawer?.querySelector('[data-price-range]') || this.querySelector('[data-price-range]');
      }
      return this.filters?.querySelector('[data-price-range]') || this.querySelector('[data-price-range]');
    }

    selectedPrice() {
      const root = this.activePriceRange();
      if (!root) return { minCents: 0, maxCents: Infinity };
      const floor = Number(root.dataset.minCents) || 0;
      const ceil = Number(root.dataset.maxCents) || 0;
      const minMajor = this.parsePriceMajor(root.querySelector('[data-price-input-min]')?.value);
      const maxMajor = this.parsePriceMajor(root.querySelector('[data-price-input-max]')?.value);
      const minCents = minMajor == null ? floor : Math.round(minMajor * 100);
      const maxCents = maxMajor == null ? Infinity : Math.round(maxMajor * 100);
      return {
        minCents,
        maxCents: maxCents > 0 ? maxCents : Infinity,
        ceil
      };
    }

    bindPriceRange() {
      this.querySelectorAll('[data-price-range]').forEach((root) => this.bindPriceRangeRoot(root));
    }

    bindPriceRangeRoot(root) {
      if (!root) return;
      const minSlider = root.querySelector('[data-price-range-min]');
      const maxSlider = root.querySelector('[data-price-range-max]');
      const minInput = root.querySelector('[data-price-input-min]');
      const maxInput = root.querySelector('[data-price-input-max]');
      const summary = root.closest('details')?.querySelector('[data-price-range-summary]');
      const fill = root.querySelector('[data-price-range-fill]');
      const floor = Number(root.dataset.minCents) || 0;
      const ceil = Number(root.dataset.maxCents) || 0;
      const step = Number(root.dataset.stepCents) || 100;
      if (!minSlider || !maxSlider || ceil <= floor) return;

      const snap = (cents) => Math.round(cents / step) * step;

      const paint = (minCents, maxCents, active) => {
        let min = Math.min(Math.max(minCents, floor), ceil);
        let max = Math.min(Math.max(maxCents, floor), ceil);
        if (min > max) {
          if (active === 'min') max = min;
          else min = max;
        }
        minSlider.value = String(snap(min));
        maxSlider.value = String(snap(max));
        const span = Math.max(ceil - floor, 1);
        const left = ((min - floor) / span) * 100;
        const right = ((max - floor) / span) * 100;
        if (fill) {
          fill.style.left = `${left}%`;
          fill.style.width = `${Math.max(right - left, 0)}%`;
        }
        if (minInput && document.activeElement !== minInput) {
          minInput.value = min <= floor ? '' : this.majorFromCents(min);
        }
        if (maxInput && document.activeElement !== maxInput) {
          maxInput.value = max >= ceil ? '' : this.majorFromCents(max);
        }
        if (summary) summary.textContent = `${money(min)} – ${money(max)}`;
        if (active === 'min') minSlider.style.zIndex = '4';
        if (active === 'max') maxSlider.style.zIndex = '4';
      };

      const fromSliders = (active) => {
        paint(Number(minSlider.value) || floor, Number(maxSlider.value) || ceil, active);
      };

      const fromFields = (active) => {
        const typedMin = this.parsePriceMajor(minInput?.value);
        const typedMax = this.parsePriceMajor(maxInput?.value);
        paint(
          typedMin == null ? floor : Math.round(typedMin * 100),
          typedMax == null ? ceil : Math.round(typedMax * 100),
          active
        );
      };

      minSlider.addEventListener('input', () => fromSliders('min'));
      maxSlider.addEventListener('input', () => fromSliders('max'));
      minInput?.addEventListener('input', () => fromFields('min'));
      maxInput?.addEventListener('input', () => fromFields('max'));
      minInput?.addEventListener('change', () => fromFields('min'));
      maxInput?.addEventListener('change', () => fromFields('max'));

      root._resetPriceRange = () => {
        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';
        paint(floor, ceil);
      };

      const params = new URL(window.location.href).searchParams;
      const urlMin = this.parsePriceMajor(params.get(minInput?.name || 'filter.v.price.gte'));
      const urlMax = this.parsePriceMajor(params.get(maxInput?.name || 'filter.v.price.lte'));
      if (urlMin != null && minInput) minInput.value = this.majorFromCents(Math.round(urlMin * 100));
      if (urlMax != null && maxInput) maxInput.value = this.majorFromCents(Math.round(urlMax * 100));

      fromFields();
    }

    syncOverflowFade(wrap, scroller) {
      if (!wrap || !scroller) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      wrap.classList.toggle('has-overflow', max > 4);
      wrap.classList.toggle('is-at-end', max <= 4 || scroller.scrollLeft >= max - 2);
    }

    syncFades() {
      this.syncOverflowFade(this.nav, this.navScroller);
      this.syncOverflowFade(this.sizeFilter, this.sizeScroller);
      this.syncOverflowFade(this.colorFilter, this.colorScroller);
      if (!this.isMobileFilter()) this.closeFilterDrawer({ silent: true });
    }

    onDocClick(event) {
      if (this.sortRoot && !this.sortRoot.contains(event.target)) this.closeSort();
      if (this.filterDrawer?.classList.contains('is-open')) return;
      if (
        this.filters?.classList.contains('is-open') &&
        !this.filters.contains(event.target) &&
        !this.filterToggle?.contains(event.target)
      ) {
        this.closeFilters();
      }
    }

    onKey(event) {
      if (event.key !== 'Escape') return;
      this.closeSort();
      this.closeFilters();
    }

    onClick(event) {
      const gridBtn = event.target.closest('[data-grid-switch] [data-cols]');
      if (gridBtn) {
        event.preventDefault();
        this.setGrid(gridBtn.dataset.grid, gridBtn.dataset.cols, true);
        return;
      }

      if (event.target.closest('[data-sort-toggle]')) {
        event.preventDefault();
        this.closeFilters();
        this.toggleSort();
        return;
      }

      const sortOption = event.target.closest('[data-sort-value]');
      if (sortOption) {
        event.preventDefault();
        this.chooseSort(sortOption);
        return;
      }

      const collectionRow = event.target.closest('[data-collection-link], .collection-filter-check:has([data-collection-link])');
      if (collectionRow) {
        const input = collectionRow.matches('[data-collection-link]')
          ? collectionRow
          : collectionRow.querySelector('[data-collection-link]');
        const href = input?.getAttribute('data-collection-link');
        if (!href) return;
        if (input.hasAttribute('data-current')) {
          input.checked = true;
          event.preventDefault();
          return;
        }
        event.preventDefault();
        this.closeFilterDrawer({ silent: true });
        if (window.themeSoftNav?.go) window.themeSoftNav.go(href);
        else window.location.assign(href);
        return;
      }

      if (event.target.closest('[data-size-filter] input[data-size-value]')) return;

      const sizeBtn = event.target.closest('[data-size-value]');
      if (sizeBtn && sizeBtn.closest('[data-size-filter]') && !sizeBtn.matches('input')) {
        event.preventDefault();
        const next = sizeBtn.getAttribute('aria-pressed') !== 'true';
        this.syncSizeValue(sizeBtn.getAttribute('data-size-value'), next);
        if (!this.filterDrawer?.classList.contains('is-open')) this.apply();
        return;
      }

      const colorBtn = event.target.closest('[data-color-value]');
      if (colorBtn && colorBtn.closest('[data-color-filter]')) {
        event.preventDefault();
        const turningOn = colorBtn.getAttribute('aria-pressed') !== 'true';
        const value = colorBtn.getAttribute('data-color-value');
        this.querySelectorAll('[data-color-filter] [data-color-value]').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(turningOn && btn.getAttribute('data-color-value') === value));
        });
        if (typeof colorBtn.blur === 'function') colorBtn.blur();
        if (!this.filterDrawer?.classList.contains('is-open')) this.apply();
        return;
      }

      if (event.target.closest('[data-in-stock]')) {
        event.preventDefault();
        const next = this.stock.getAttribute('aria-pressed') !== 'true';
        this.stock.setAttribute('aria-pressed', String(next));
        /* Client-side only: keep sold-out cards in the DOM (hidden) so toggle
           is instant — no section fetch / replaceWith remount flicker. */
        this.syncProductVisibility();
        const url = this.urlFromState();
        window.history.pushState({}, '', url.toString());
        return;
      }

      if (event.target.closest('[data-filter-apply]')) {
        event.preventDefault();
        this.apply();
        return;
      }

      if (event.target.closest('[data-filter-clear]')) {
        event.preventDefault();
        this.clearDrawerFilters();
        return;
      }

      if (event.target.closest('[data-filter-close]')) {
        event.preventDefault();
        this.closeFilterDrawer();
        return;
      }

      if (event.target.closest('[data-filter-toggle]')) {
        this.closeSort();
        if (this.isMobileFilter() && this.filterDrawer) {
          if (this.filterDrawer.classList.contains('is-open')) this.closeFilterDrawer();
          else this.openFilterDrawer();
          return;
        }
        const open = this.filters?.classList.toggle('is-open');
        this.filterToggle?.setAttribute('aria-expanded', String(Boolean(open)));
        return;
      }

      if (event.target.closest('[data-load-more]')) {
        this.loadMore(event);
      }
    }

    setGrid(target, cols, remember) {
      if (!cols) return;
      const key = target === 'mobile' ? '--grid-mobile' : '--grid-desktop';
      const grid = this.grid;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const shouldAnimate =
        remember &&
        grid &&
        (target === 'mobile') === mobile &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.style.setProperty(key, String(cols));
      if (this.parentElement?.id) {
        this.parentElement.style.setProperty(key, String(cols));
      }
      this.querySelectorAll(`[data-grid-switch] [data-grid="${target}"]`).forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn.dataset.cols === String(cols)));
      });

      if (shouldAnimate) this.replayGridAnimation(grid);

      if (remember) {
        collectionGridPrefs[target] = String(cols);
        try {
          sessionStorage.setItem(`wv:grid-${target}`, String(cols));
        } catch (error) {
          /* Private mode. */
        }
      }
    }

    replayGridAnimation(grid) {
      if (!grid) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!grid.hasAttribute('data-reveal-group')) {
        grid.setAttribute('data-reveal-group', '');
      }
      const cards = [...grid.querySelectorAll('.product-card-reveal')].filter((el) => !el.closest('[hidden]'));
      if (!cards.length) return;
      grid.classList.remove('is-grid-replay');
      cards.forEach((el, index) => {
        el.style.setProperty('--card-reveal-index', String(index));
        el.classList.remove('is-visible');
      });
      void grid.offsetWidth;
      grid.classList.add('is-grid-replay');
      window.requestAnimationFrame(() => {
        cards.forEach((el) => el.classList.add('is-visible'));
      });
      const wait = this.gridReplayMs(grid, cards.length);
      window.setTimeout(() => grid.classList.remove('is-grid-replay'), wait);
    }

    gridReplayMs(grid, cardCount) {
      const duration = Number.parseFloat(getComputedStyle(grid).getPropertyValue('--card-reveal-duration')) || 600;
      const step = Number.parseFloat(getComputedStyle(grid).getPropertyValue('--card-stagger-step')) || 60;
      const n =
        typeof cardCount === 'number'
          ? cardCount
          : [...grid.querySelectorAll('.product-card-reveal')].filter((el) => !el.closest('[hidden]')).length;
      return duration + Math.max(n, 1) * step + 80;
    }

    closeFilters() {
      this.filters?.classList.remove('is-open');
      this.closeFilterDrawer();
      this.filterToggle?.setAttribute('aria-expanded', 'false');
    }

    setFilterOverlay(open) {
      document.documentElement.classList.toggle('has-collection-filters', open);
      document.body.classList.toggle('has-collection-filters', open);
    }

    openFilterDrawer() {
      if (!this.filterDrawer) return;
      this.filterDrawer.classList.add('is-open');
      this.filterDrawer.setAttribute('aria-hidden', 'false');
      this.filterToggle?.setAttribute('aria-expanded', 'true');
      this.setFilterOverlay(true);
      if (!this._filterScrollLocked) {
        scrollLock.lock();
        this._filterScrollLocked = true;
      }
      this.releaseFilterFocus?.();
      this.releaseFilterFocus = trapFocus(this.filterPanel || this.filterDrawer);
      this.filterPanel?.focus({ preventScroll: true });
    }

    closeFilterDrawer(options = {}) {
      this.setFilterOverlay(false);
      if (!this.filterDrawer) {
        this.releaseFilterFocus?.();
        this.releaseFilterFocus = null;
        if (this._filterScrollLocked) {
          scrollLock.unlock();
          this._filterScrollLocked = false;
        }
        return;
      }
      const wasOpen = this.filterDrawer.classList.contains('is-open');
      this.filterDrawer.classList.remove('is-open');
      this.filterDrawer.setAttribute('aria-hidden', 'true');
      this.filterToggle?.setAttribute('aria-expanded', 'false');
      this.releaseFilterFocus?.();
      this.releaseFilterFocus = null;
      if (this._filterScrollLocked) {
        scrollLock.unlock();
        this._filterScrollLocked = false;
      }
      if (wasOpen && !options.silent) this.filterToggle?.focus({ preventScroll: true });
    }

    clearDrawerFilters() {
      this.querySelectorAll('[data-size-filter] [data-size-value]').forEach((el) => {
        if (el.matches('input')) el.checked = false;
        else el.setAttribute('aria-pressed', 'false');
      });
      this.querySelectorAll('[data-color-filter] [data-color-value]').forEach((btn) => {
        btn.setAttribute('aria-pressed', 'false');
      });
      this.filterDrawer?.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (input.hasAttribute('data-collection-link')) return;
        input.checked = false;
      });
      this.filterDrawer?.querySelector('[data-price-range]')?._resetPriceRange?.();
      this.apply();
    }

    toggleSort() {
      const open = this.sortMenu?.hidden;
      if (open) this.openSort();
      else this.closeSort();
    }

    openSort() {
      if (!this.sortMenu) return;
      this.sortMenu.hidden = false;
      this.sortToggle?.setAttribute('aria-expanded', 'true');
      this.sortRoot?.classList.add('is-open');
      reveal?.reset(this.sortMenu);
      /* Double-rAF so every option (including the last) replays from hidden. */
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => reveal?.play(this.sortMenu));
      });
    }

    closeSort() {
      if (!this.sortMenu) return;
      this.sortRoot?.classList.remove('is-open');
      this.sortToggle?.setAttribute('aria-expanded', 'false');
      reveal?.reset(this.sortMenu);
      const menu = this.sortMenu;
      window.setTimeout(() => {
        if (!this.sortRoot?.classList.contains('is-open')) menu.hidden = true;
      }, 280);
    }

    chooseSort(option) {
      const value = option.dataset.sortValue;
      if (this.sortSelect) this.sortSelect.value = value;
      this.sortToggle?.setAttribute(
        'aria-label',
        `${theme.strings.sortBy || 'Sort by'}: ${option.textContent.trim()}`
      );
      this.sortMenu?.querySelectorAll('[data-sort-value]').forEach((btn) => {
        const active = btn === option;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', String(active));
      });
      this.closeSort();
      this.apply();
    }

    selectedSizes() {
      const values = new Set();
      this.querySelectorAll('[data-size-filter] [data-size-value]').forEach((el) => {
        const value = el.getAttribute('data-size-value');
        if (!value) return;
        if (el.matches('input') ? el.checked : el.getAttribute('aria-pressed') === 'true') {
          values.add(value);
        }
      });
      return [...values];
    }

    selectedColors() {
      return [
        ...new Set(
          [...this.querySelectorAll('[data-color-filter] [data-color-value][aria-pressed="true"]')]
            .map((btn) => btn.getAttribute('data-color-value'))
            .filter(Boolean)
        )
      ];
    }

    hydrateSizeFromUrl() {
      const root = this.querySelector('[data-size-filter]');
      if (!root) return;
      const param = root.dataset.param || 'filter.v.option.size';
      const selected = new URL(window.location.href).searchParams.getAll(param);
      this.querySelectorAll('[data-size-filter] [data-size-value]').forEach((el) => {
        const value = el.getAttribute('data-size-value');
        const on = selected.includes(value);
        if (el.matches('input')) el.checked = on;
        else el.setAttribute('aria-pressed', String(on));
      });
    }

    hydrateColorFromUrl() {
      const root = this.querySelector('[data-color-filter]');
      if (!root) return;
      const param = root.dataset.param || 'filter.v.option.color';
      const selected = new URL(window.location.href).searchParams.getAll(param);
      this.querySelectorAll('[data-color-filter] [data-color-value]').forEach((btn) => {
        const value = btn.getAttribute('data-color-value');
        btn.setAttribute('aria-pressed', String(selected.includes(value)));
      });
    }

    urlFromState() {
      const url = new URL(window.location.href);
      url.search = '';
      const sizeParam = this.querySelector('[data-size-filter]')?.dataset.param;
      const colorParam = this.querySelector('[data-color-filter]')?.dataset.param;
      const inputRoot =
        this.isMobileFilter() && this.filterDrawer ? this.filterDrawer : this.filterForm();
      inputRoot?.querySelectorAll('input').forEach((input) => {
        if (input.hasAttribute('data-collection-link') || !input.name) return;
        if (input.type === 'range') return;
        if (input.name === 'sort_by' || input.name === 'filter.v.availability') return;
        if (input.hasAttribute('data-price-input-min') || input.hasAttribute('data-price-input-max')) return;
        if (sizeParam && input.name === sizeParam) return;
        if (colorParam && input.name === colorParam) return;
        if (input.type === 'checkbox') {
          if (input.checked) url.searchParams.append(input.name, input.value);
        } else if (input.value && input.type !== 'hidden') {
          url.searchParams.set(input.name, input.value);
        } else if (input.type === 'hidden' && input.value) {
          url.searchParams.set(input.name, input.value);
        }
      });
      const priceRoot = this.activePriceRange();
      const priceMin = priceRoot?.querySelector('[data-price-input-min]');
      const priceMax = priceRoot?.querySelector('[data-price-input-max]');
      if (priceMin?.name && priceMin.value) url.searchParams.set(priceMin.name, priceMin.value);
      if (priceMax?.name && priceMax.value) url.searchParams.set(priceMax.name, priceMax.value);
      if (this.sortSelect?.value) url.searchParams.set('sort_by', this.sortSelect.value);
      if (this.stock?.getAttribute('aria-pressed') === 'true') {
        url.searchParams.set(this.stock.dataset.param || 'filter.v.availability', this.stock.dataset.value || '1');
      }
      this.selectedSizes().forEach((value) => {
        url.searchParams.append(sizeParam || 'filter.v.option.size', value);
      });
      this.selectedColors().forEach((value) => {
        url.searchParams.append(colorParam || 'filter.v.option.color', value);
      });
      return url;
    }

    async apply(options = {}) {
      this._applyId = (this._applyId || 0) + 1;
      const requestId = this._applyId;
      this._abort?.abort();
      this._abort = new AbortController();

      const url = this.urlFromState();
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const grid = this.grid;
      const keepVisible = Boolean(options.keepVisible);
      /* keepVisible: skip exit fade so in-stock toggle does not flash an empty grid. */
      if (grid && !reduceMotion && !keepVisible) {
        grid.classList.add('is-collection-exit');
        await new Promise((resolve) => window.setTimeout(resolve, 180));
        if (requestId !== this._applyId) return;
      }

      /* Let the local card replay finish before replaceWith swaps the DOM. */
      const replayWait =
        options.afterReplay && grid && !reduceMotion ? this.gridReplayMs(grid) : 0;

      try {
        const fetchPromise = (async () => {
          const response = await fetch(fetchUrl.toString(), { signal: this._abort.signal });
          if (requestId !== this._applyId) return null;
          const html = await response.text();
          if (requestId !== this._applyId) return null;
          return html;
        })();
        const waitPromise = replayWait
          ? new Promise((resolve) => window.setTimeout(resolve, replayWait))
          : Promise.resolve();

        const [html] = await Promise.all([fetchPromise, waitPromise]);
        if (requestId !== this._applyId || html == null) return;

        /* Parse into the live document so custom elements upgrade reliably. */
        const holder = document.createElement('div');
        holder.innerHTML = html;
        const incoming =
          holder.querySelector('collection-grid') ||
          holder.querySelector(`[data-section-id="${this.dataset.sectionId}"]`) ||
          parseSection(html, 'collection-grid');

        window.history.pushState({}, '', url.toString());
        if (incoming) {
          incoming.querySelectorAll('.product-card-reveal, .reveal').forEach((el) => el.classList.add('is-visible'));
          const nextGrid = incoming.querySelector('[data-product-grid]');
          /* keepVisible swaps in place — no enter fade that would blank the grid again. */
          if (nextGrid && !reduceMotion && !keepVisible) nextGrid.classList.add('is-collection-enter');
          this.replaceWith(incoming);
          if (window.MediaStates?.initAll) window.MediaStates.initAll(incoming);
          if (nextGrid && !reduceMotion && !keepVisible) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => nextGrid.classList.remove('is-collection-enter'));
            });
          }
        }
        Wishlist.sync();
      } catch (error) {
        if (error?.name === 'AbortError') return;
        console.warn('[collection] filter apply failed', error);
      }
    }

    syncProductVisibility() {
      const stockOn = this.stock?.getAttribute('aria-pressed') === 'true';
      const sizes = this.selectedSizes();
      const colors = this.selectedColors();
      const price = this.selectedPrice();
      const priceOn = price.minCents > 0 || Number.isFinite(price.maxCents);
      const availableOnly = (this.sizeFilter?.dataset.mode || this.dataset.sizeMode) !== 'all';
      const colorAvailableOnly = (this.colorFilter?.dataset.mode || this.dataset.colorMode) !== 'all';
      const items = [...this.querySelectorAll('[data-product-grid] > li')];
      if (!items.length) return;
      items.forEach((item) => {
        const sold = Boolean(item.querySelector('.product-card--sold-out') || item.classList.contains('is-sold-out'));
        let hide = Boolean(stockOn && sold);
        if (sizes.length && availableOnly) {
          const hay = item.dataset.availableSizes || '';
          const match = sizes.some((size) => hay.includes(`|${size}|`));
          if (!match) hide = true;
        }
        if (colors.length && colorAvailableOnly) {
          const hay = item.dataset.availableColors || '';
          const match = colors.some((color) => hay.includes(`|${color}|`));
          if (!match) hide = true;
        }
        if (priceOn) {
          const itemMin = Number(item.dataset.priceMin);
          const itemMax = Number(item.dataset.priceMax);
          if (Number.isFinite(itemMin) && itemMin > price.maxCents) hide = true;
          if (Number.isFinite(itemMax) && itemMax < price.minCents) hide = true;
        }
        item.hidden = hide;
      });
      /* Do not rewrite [data-collection-count] from visible page items — paginated
         collections would replace the true collection total with the page size. */
    }

    async loadMore(event) {
      event.preventDefault();
      const link = event.target.closest('[data-load-more]');
      const grid = this.grid || this.querySelector('[data-product-grid]');
      if (!link || !grid) return;
      if (link.classList.contains('is-loading')) return;

      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');
      let spinner = link.querySelector('[data-load-more-spinner]');
      if (!spinner) {
        spinner = document.createElement('span');
        spinner.className = 'button__spinner';
        spinner.dataset.loadMoreSpinner = '';
        spinner.setAttribute('aria-hidden', 'true');
        link.append(spinner);
      }
      spinner.hidden = false;

      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.toString());
        const html = await response.text();
        const incoming = parseSection(html, '[data-product-grid]');
        incoming?.querySelectorAll(':scope > li').forEach((item) => grid.appendChild(item));
        this.grid = grid;
        if (window.MediaStates?.initAll) window.MediaStates.initAll(grid);
        reveal.scan(grid);
        Wishlist.sync(grid);
        this.syncProductVisibility();
        const next = parseSection(html, '[data-load-more]');
        if (next) link.href = next.href;
        else link.parentElement?.remove();
      } catch (error) {
        console.warn('[collection] load more failed', error);
      } finally {
        if (link.isConnected) {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          const spin = link.querySelector('[data-load-more-spinner]');
          if (spin) spin.hidden = true;
        }
      }
    }
  }

  class ProductCardGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-card-slide]')];
      this.dots = [...this.querySelectorAll('[data-card-dot]')];
      this.track = this.querySelector('[data-card-track]');
      this.index = 0;
      this.moved = false;
      this.hovering = false;
      this.inView = true;
      this.autoplayOrigin = null;
      this._autoTimer = 0;
      this.mq = window.matchMedia('(min-width: 750px)');
      this.hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onBreakpoint = this.onBreakpoint.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.classList.add('is-ready');

      if (this.slides.length < 2) {
        this.display(0, true);
        return;
      }

      this.mq.addEventListener('change', this.onBreakpoint);
      this.hoverMq.addEventListener('change', this.onBreakpoint);
      this.motionMq.addEventListener('change', this.onBreakpoint);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.bind();
      this.display(this.index, true);
    }

    disconnectedCallback() {
      this.unbind();
      this.mq?.removeEventListener('change', this.onBreakpoint);
      this.hoverMq?.removeEventListener('change', this.onBreakpoint);
      this.motionMq?.removeEventListener('change', this.onBreakpoint);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    get isDesktop() {
      return this.mq?.matches;
    }

    get prefersReducedMotion() {
      return Boolean(this.motionMq?.matches);
    }

    get canHover() {
      return Boolean(this.isDesktop && this.hoverMq?.matches && this.dataset.hoverSecond === 'true');
    }

    get canAutoplay() {
      return Boolean(
        this.dataset.autoplay === 'true' &&
          this.slides.length > 1 &&
          this.isDesktop &&
          this.hoverMq?.matches &&
          !this.prefersReducedMotion
      );
    }

    get autoplaySpeed() {
      const ms = Number(this.dataset.autoplaySpeed);
      return Number.isFinite(ms) && ms >= 250 ? ms : 3000;
    }

    get sliderActive() {
      if (this.slides.length < 2) return false;
      return this.isDesktop ? this.dataset.nav === 'true' : this.dataset.mobileSlider === 'true';
    }

    onBreakpoint() {
      this.stopAutoplay();
      this.hovering = false;
      this.autoplayOrigin = null;
      this.index = 0;
      this.bind();
      this.display(0, true);
    }

    onVisibility() {
      if (document.hidden) this.stopAutoplay();
    }

    bind() {
      this.unbind();

      if (this.sliderActive) {
        this.prev = this.querySelector('[data-card-prev]');
        this.next = this.querySelector('[data-card-next]');
        this._onPrev = (event) => this.onNav(event, -1);
        this._onNext = (event) => this.onNav(event, 1);
        this.prev?.addEventListener('click', this._onPrev);
        this.next?.addEventListener('click', this._onNext);
        if (!this.isDesktop) {
          this._onPointer = (event) => this.onPointerDown(event);
          this.addEventListener('pointerdown', this._onPointer);
        }
      }

      if (this.canAutoplay || this.canHover) {
        this._onEnter = () => this.onEnter();
        this._onLeave = () => this.onLeave();
        this.addEventListener('mouseenter', this._onEnter);
        this.addEventListener('mouseleave', this._onLeave);
      }

      this.observeInView();
    }

    unbind() {
      this.stopAutoplay();
      this.unobserveInView();
      this.prev?.removeEventListener('click', this._onPrev);
      this.next?.removeEventListener('click', this._onNext);
      if (this._onPointer) this.removeEventListener('pointerdown', this._onPointer);
      if (this._onEnter) this.removeEventListener('mouseenter', this._onEnter);
      if (this._onLeave) this.removeEventListener('mouseleave', this._onLeave);
      this.prev = null;
      this.next = null;
      this._onPrev = null;
      this._onNext = null;
      this._onPointer = null;
      this._onEnter = null;
      this._onLeave = null;
    }

    observeInView() {
      if (!this.canAutoplay) return;
      this.inView = true;
      this._io = new IntersectionObserver(
        (entries) => {
          this.inView = entries.some((entry) => entry.isIntersecting);
          if (!this.inView) this.stopAutoplay();
        },
        { threshold: 0.35 }
      );
      this._io.observe(this);
    }

    unobserveInView() {
      this._io?.disconnect();
      this._io = null;
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.canAutoplay || this.inView === false) return;
      if (this.autoplayOrigin == null) this.autoplayOrigin = this.index;
      this.hovering = true;
      this._autoTimer = window.setInterval(() => {
        if (!this.inView || document.hidden) {
          this.stopAutoplay();
          return;
        }
        this.go(this.index + 1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this._autoTimer) {
        window.clearInterval(this._autoTimer);
        this._autoTimer = 0;
      }
    }

    onNav(event, step) {
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget?.blur();
      if (!this.sliderActive) return;
      /* Prefer the active slide index so prev/next stay in sync after hover-swap. */
      const activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      const current =
        activeIndex >= 0 ? activeIndex : this.hovering ? Math.min(1, this.slides.length - 1) : this.index;
      this.index = current;
      this.go(current + step);
      if (this.canAutoplay && this.hovering) this.startAutoplay();
    }

    onEnter() {
      if (this.canAutoplay) {
        this.startAutoplay();
        return;
      }
      if (!this.canHover) return;
      this.hovering = true;
      this.display(Math.min(1, this.slides.length - 1));
    }

    onLeave() {
      if (this.canAutoplay || this._autoTimer) {
        const origin = this.autoplayOrigin == null ? 0 : this.autoplayOrigin;
        this.stopAutoplay();
        this.hovering = false;
        this.autoplayOrigin = null;
        this.go(origin);
        return;
      }
      if (!this.canHover) return;
      this.hovering = false;
      this.display(this.index);
    }

    onPointerDown(event) {
      if (this.isDesktop || !this.sliderActive) return;
      if (event.target.closest('[data-card-nav], [data-wishlist-toggle]')) return;

      const startX = event.clientX;
      this.moved = false;

      const onMove = (moveEvent) => {
        const dx = moveEvent.clientX - startX;
        if (Math.abs(dx) > 24) this.moved = true;
      };

      const onUp = (upEvent) => {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        const dx = upEvent.clientX - startX;
        if (Math.abs(dx) < 40) return;
        upEvent.preventDefault();
        this.go(this.index + (dx < 0 ? 1 : -1));
      };

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp, { once: true });

      this.addEventListener(
        'click',
        (clickEvent) => {
          if (!this.moved) return;
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        },
        { capture: true, once: true }
      );
    }

    display(index, instant) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      const current = ((index % count) + count) % count;
      this.style.setProperty('--card-slide', String(current));
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      if (this.track && this.sliderActive && this.dataset.transition === 'slide') {
        this.track.style.transitionDuration = instant ? '0ms' : '';
        this.track.style.transform = `translateX(-${current * 100}%)`;
      } else if (this.track) {
        this.track.style.transitionDuration = '';
        this.track.style.transform = '';
      }
    }

    go(next, instant) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      this.index = ((next % count) + count) % count;
      this.display(this.index, instant);
    }
  }

  /* The bag link points at /cart so it works without JS; with JS it opens the
     drawer instead. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    drawer.open();
  });

  /* Overlays coordinate through this event so only one holds the scroll lock. */
  document.addEventListener('theme:overlay:request', (event) => {
    const source = event.detail?.source;
    document.querySelectorAll('cart-drawer, quick-buy-drawer').forEach((el) => {
      if (el !== source) el.close?.();
    });
  });

  document.addEventListener('click', async (event) => {
    const qty = event.target.closest('.cart-page [data-quantity-change]');
    const remove = event.target.closest('.cart-page [data-remove-item]');
    if (qty) {
      const input = qty.parentElement.querySelector('[data-quantity-input]');
      input.value = Math.max(0, Number(input.value) + Number(qty.dataset.quantityChange));
      await Cart.change(input.dataset.lineKey, Number(input.value));
      window.location.reload();
    }
    if (remove) {
      await Cart.change(remove.dataset.lineKey, 0);
      window.location.reload();
    }
  });

  const Wishlist = {
    key: 'wv:wishlist',
    accountPrefix: 'wv:wishlist:c',
    cookieName: 'wv_wishlist',
    persistTimer: 0,
    customerId() {
      return String(theme.customerId || document.documentElement.getAttribute('data-customer-id') || '').trim();
    },
    storageKey() {
      const id = this.customerId();
      return id ? `${this.accountPrefix}${id}` : this.key;
    },
    normalize(raw) {
      if (raw == null || raw === '') return [];
      let list = raw;
      if (typeof list === 'string') {
        try {
          list = JSON.parse(list);
        } catch (error) {
          return [];
        }
      }
      if (!Array.isArray(list)) return [];
      const mapped = list
        .map((item) => {
          if (item == null) return null;
          if (typeof item === 'string' || typeof item === 'number') {
            const value = String(item).trim();
            if (!value) return null;
            /* Numeric-only ids without handle are ghosts — drop them. */
            if (/^\d+$/.test(value)) return null;
            return {
              id: '',
              handle: value,
              title: '',
              url: `/products/${value}`,
              image: '',
              price: 0,
              compare: 0,
              available: true
            };
          }
          const handle = String(item.handle || item.productHandle || '').trim();
          const id = String(item.id || item.product_id || item.productId || '').replace(/^gid:\/\/shopify\/Product\//, '');
          if (!handle) return null;
          let image = item.image || item.featured_image || '';
          if (image && typeof image === 'object') {
            image = image.src || image.url || image.preview_image?.src || '';
          }
          image = String(image || '').trim();
          if (image.startsWith('//')) image = `https:${image}`;
          return {
            id,
            handle,
            title: item.title || '',
            url: item.url || `/products/${handle}`,
            image,
            price: Number(item.price || 0),
            compare: Number(item.compare || item.compare_at_price || 0),
            available: item.available !== false,
            options: item.options || [],
            variants: item.variants || []
          };
        })
        .filter(Boolean);
      return this.mergeLists(mapped);
    },
    readFrom(key) {
      try {
        return this.normalize(JSON.parse(localStorage.getItem(key) || '[]'));
      } catch (error) {
        return [];
      }
    },
    cookieKey() {
      const id = this.customerId();
      return id ? `${this.cookieName}_c${id}` : this.cookieName;
    },
    readCookie() {
      try {
        const name = this.cookieKey();
        const row = document.cookie.split('; ').find((part) => part.startsWith(`${name}=`));
        if (!row) return [];
        return this.normalize(decodeURIComponent(row.slice(name.length + 1)));
      } catch (error) {
        return [];
      }
    },
    mergeLists(...lists) {
      const order = [];
      const byHandle = new Map();
      const byId = new Map();

      lists.flat().forEach((item) => {
        if (!item || (!item.handle && !item.id)) return;

        const prev =
          (item.handle && byHandle.get(item.handle)) ||
          (item.id && byId.get(String(item.id))) ||
          null;

        if (prev) {
          const merged = { ...prev, ...item };
          if (prev.handle) byHandle.delete(prev.handle);
          if (prev.id) byId.delete(String(prev.id));
          if (merged.handle) byHandle.set(merged.handle, merged);
          if (merged.id) byId.set(String(merged.id), merged);
          const idx = order.indexOf(prev);
          if (idx >= 0) order[idx] = merged;
          return;
        }

        if (item.handle) byHandle.set(item.handle, item);
        if (item.id) byId.set(String(item.id), item);
        order.push(item);
      });

      return order;
    },
    read() {
      return this.readFrom(this.storageKey());
    },
    writeCookie(items) {
      try {
        const compact = items.map((item) => ({
          id: item.id,
          handle: item.handle,
          title: item.title,
          url: item.url,
          image: item.image,
          price: item.price,
          compare: item.compare,
          available: item.available
        }));
        let payload = JSON.stringify(compact);
        while (payload.length > 1400 && compact.length > 1) {
          compact.pop();
          payload = JSON.stringify(compact);
        }
        const days = this.customerId() ? 400 : 60;
        document.cookie = `${this.cookieKey()}=${encodeURIComponent(payload)}; path=/; max-age=${days * 86400}; SameSite=Lax`;
      } catch (error) {
        /* Cookie blocked. */
      }
    },
    write(items) {
      const list = this.normalize(items);
      try {
        localStorage.setItem(this.storageKey(), JSON.stringify(list));
      } catch (error) {
        /* Storage blocked. */
      }
      this.writeCookie(list);
      this.queuePersist(list);
      return list;
    },
    queuePersist(items) {
      if (!this.customerId()) return;
      window.clearTimeout(this.persistTimer);
      this.persistTimer = window.setTimeout(() => {
        this.persistAccount(items);
      }, 450);
    },
    async persistAccount(items) {
      const id = this.customerId();
      if (!id) return;
      const value = JSON.stringify(
        items.map((item) => ({
          id: item.id,
          handle: item.handle,
          title: item.title,
          url: item.url,
          image: item.image,
          price: item.price,
          compare: item.compare,
          available: item.available
        }))
      );
      const body = JSON.stringify({
        query: `mutation MetafieldsSet($metafields: [MetafieldsSetInput!]!) {
          metafieldsSet(metafields: $metafields) { userErrors { message } }
        }`,
        variables: {
          metafields: [
            {
              ownerId: `gid://shopify/Customer/${id}`,
              namespace: 'wennyvisual',
              key: 'wishlist',
              type: 'json',
              value
            }
          ]
        }
      });
      const urls = ['/account/customer/api/2025-01/graphql', '/account/customer/api/unstable/graphql'];
      for (const url of urls) {
        try {
          const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body
          });
          if (response.ok) return;
        } catch (error) {
          /* Next endpoint. */
        }
      }
    },
    boot() {
      if (this._booted) return;
      this._booted = true;
      const id = this.customerId();
      const guest = this.readFrom(this.key);
      const cookie = this.readCookie();
      const server = this.normalize(theme.customerWishlist);
      if (!id) {
        const merged = this.mergeLists(guest, cookie);
        /* Always rewrite so id/handle duplicates are cleaned from storage. */
        this.write(merged);
        return;
      }
      const account = this.readFrom(`${this.accountPrefix}${id}`);
      this.write(this.mergeLists(server, account, cookie, guest));
      try {
        localStorage.removeItem(this.key);
      } catch (error) {
        /* Storage blocked. */
      }
      document.cookie = `${this.cookieName}=; path=/; max-age=0; SameSite=Lax`;
    },
    recordFromButton(btn) {
      let extra = {};
      try {
        extra = JSON.parse(btn.dataset.wishlistItem || '{}');
      } catch (error) {
        extra = {};
      }
      const handle = btn.dataset.productHandle || extra.handle || '';
      let image = extra.image || '';
      if (image && typeof image === 'object') {
        image = image.src || image.url || '';
      }
      image = String(image || '').trim();
      if (image.startsWith('//')) image = `https:${image}`;
      return {
        id: String(btn.dataset.productId || extra.id || ''),
        handle,
        title: btn.dataset.productTitle || extra.title || '',
        url: extra.url || (handle ? `/products/${handle}` : ''),
        image,
        price: Number(extra.price || 0),
        compare: Number(extra.compare || 0),
        available: extra.available !== false,
        options: extra.options || [],
        variants: extra.variants || []
      };
    },
    has(id, handle) {
      const key = String(id || '');
      return this.read().some(
        (item) => (key && String(item.id) === key) || (handle && item.handle === handle)
      );
    },
    toggle(record) {
      if (!record || !record.handle) return this.read();
      const items = this.read();
      const index = items.findIndex(
        (item) =>
          item.handle === record.handle ||
          (record.id && item.id && String(item.id) === String(record.id))
      );
      if (index >= 0) items.splice(index, 1);
      else items.push(record);
      this.write(items);
      return items;
    },
    labels(title) {
      const name = title || '';
      return {
        add: (theme.strings.wishlistAdd || 'Save [title]').replace('[title]', name),
        remove: (theme.strings.wishlistRemove || 'Remove [title]').replace('[title]', name)
      };
    },
    updateCount() {
      const count = this.read().filter((item) => item && String(item.handle || '').trim()).length;
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = String(count);
      });
      document.querySelectorAll('[data-wishlist-count-wrap]').forEach((el) => {
        el.hidden = count < 1;
        if (count < 1) el.setAttribute('hidden', '');
        else el.removeAttribute('hidden');
      });
      document.querySelectorAll('[data-wishlist-count-label]').forEach((el) => {
        el.textContent = (theme.strings.wishlistCount || '[count]').replace('[count]', String(count));
      });
      document.querySelectorAll('[data-wishlist-toolbar]').forEach((el) => {
        el.hidden = count < 1;
      });
    },
    pruneHandles(badHandles = []) {
      const bad = new Set((badHandles || []).map((h) => String(h || '').trim()).filter(Boolean));
      if (!bad.size) return this.read();
      const next = this.read().filter((item) => item && item.handle && !bad.has(String(item.handle)));
      this.write(next);
      this.sync();
      return next;
    },
    /* Drop localStorage/cookie ghosts whose product pages no longer exist (fixes badge 3→0). */
    async validateStored() {
      if (this._validating) return;
      const items = this.read().filter((item) => item && String(item.handle || '').trim());
      if (!items.length) {
        this.updateCount();
        return;
      }
      this._validating = true;
      try {
        const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
        const bad = [];
        await Promise.all(
          items.map(async (item) => {
            const handle = String(item.handle).trim();
            try {
              const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
                credentials: 'same-origin'
              });
              if (!response.ok) bad.push(handle);
            } catch (error) {
              bad.push(handle);
            }
          })
        );
        if (bad.length) this.pruneHandles(bad);
        else this.updateCount();
      } finally {
        this._validating = false;
      }
    },
    clear() {
      this.write([]);
      this.sync();
      document.dispatchEvent(new CustomEvent('theme:wishlist:change', { detail: { items: [] } }));
      return [];
    },
    sync(root = document) {
      root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const saved = this.has(btn.dataset.productId, btn.dataset.productHandle);
        const copy = this.labels(btn.dataset.productTitle || '');
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', String(saved));
        btn.setAttribute('aria-label', saved ? copy.remove : copy.add);
        const hidden = btn.querySelector('[data-wishlist-label]');
        if (hidden) hidden.textContent = saved ? copy.remove : copy.add;
      });
      this.updateCount();
    }
  };

  Wishlist.boot();
  Wishlist.sync();
  Wishlist.validateStored();

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    Wishlist.toggle(Wishlist.recordFromButton(toggle));
    Wishlist.sync();
    document.dispatchEvent(new CustomEvent('theme:wishlist:change', { detail: { items: Wishlist.read() } }));
  });

  document.addEventListener('click', async (event) => {
    const size = event.target.closest('[data-quick-size]');
    if (size) {
      if (size.closest('cart-drawer')) return;
      event.preventDefault();
      const root = size.closest('[data-quick-add-root]');
      root?.querySelectorAll('[data-quick-size]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn === size));
      });
      const add = root?.querySelector('[data-quick-add]');
      if (add) add.dataset.variantId = size.dataset.variantId;
      if (typeof size.blur === 'function') size.blur();

      /* Compact layout: choosing a size adds immediately. */
      const compact = root?.dataset.quickAddLayout === 'compact';
      if (compact && root?.hasAttribute('data-quick-add-expandable')) {
        const id = Number(size.dataset.variantId);
        if (!id) return;
        const trigger = add || size;
        if (trigger.classList.contains('is-loading')) return;
        clearAddError(trigger);
        setAddLoading(trigger, true);
        try {
          await Cart.add(id, 1);
          await Cart.refresh();
          Cart.open();
          root.classList.remove('is-open');
          const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
          if (rail) rail.hidden = true;
          add?.setAttribute('aria-expanded', 'false');
        } catch (error) {
          showAddError(trigger, error?.message || theme.strings.cartError);
        } finally {
          setAddLoading(trigger, false);
        }
      }
      return;
    }

    const add = event.target.closest('[data-quick-add]');
    if (!add || add.closest('cart-drawer')) return;
    if (add.disabled || add.classList.contains('is-loading')) return;
    event.preventDefault();

    const root = add.closest('[data-quick-add-root]');
    const expandable = root?.hasAttribute('data-quick-add-expandable');
    if (root?.dataset.quickAddLayout === 'compact' && expandable) {
      const open = root.classList.toggle('is-open');
      const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
      if (rail) rail.hidden = !open;
      add.setAttribute('aria-expanded', String(open));
      if (open) {
        const sizesEl = root.querySelector('.quick-add__sizes');
        if (sizesEl) bindDragScroll(sizesEl);
      }
      return;
    }

    const id = Number(add.dataset.variantId);
    if (!id) return;
    clearAddError(add);
    setAddLoading(add, true);
    try {
      await Cart.add(id, 1);
      await Cart.refresh();
      Cart.open();
    } catch (error) {
      showAddError(add, error?.message || theme.strings.cartError);
    } finally {
      setAddLoading(add, false);
    }
  });

  /* Close compact quick-add when clicking outside. */
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-quick-add-root].is-open')) return;
    document.querySelectorAll('[data-quick-add-root].is-open').forEach((root) => {
      root.classList.remove('is-open');
      const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
      if (rail) rail.hidden = true;
      root.querySelector('[data-quick-add]')?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-quick-add-root].is-open').forEach((root) => {
      root.classList.remove('is-open');
      const rail = root.querySelector('.quick-add__rail, [data-option-rail]');
      if (rail) rail.hidden = true;
      root.querySelector('[data-quick-add]')?.setAttribute('aria-expanded', 'false');
    });
  });

  ColorMode.init();

  /* Shared surface for component scripts (header.js and later components).
     Assigned before customElements.define so a duplicate-define throw cannot
     leave Wishlist unreachable from the overlay. */
  window.Theme = {
    Cart,
    ColorMode,
    Wishlist,
    pageReveal,
    bannerEntrance,
    bindDragScroll,
    unbindDragScroll,
    money,
    saleBadgeMarkup,
    parseSection,
    reveal,
    routes: theme.routes || {},
    scrollLock,
    strings: theme.strings || {},
    trapFocus
  };

  class ProductTrust extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.layout = this.dataset.layout || 'slider';
      this.pagination = this.dataset.pagination || 'dots';
      this.track = this.querySelector('[data-trust-track]');
      this.viewport = this.querySelector('[data-trust-viewport]');
      this.items = [...this.querySelectorAll('[data-trust-item]')];
      this.dots = [...this.querySelectorAll('[data-trust-dot]')];
      this.thumb = this.querySelector('[data-trust-scrollthumb]');
      this.index = 0;

      if (this.layout !== 'slider' || this.items.length < 2) return;

      this.querySelector('[data-trust-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-trust-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i));
      });

      if (this.pagination === 'scrollbar' && this.viewport) {
        bindDragScroll(this.viewport);
        this.viewport.addEventListener('scroll', () => this.syncScrollThumb(), { passive: true });
        this.syncScrollThumb();
        window.addEventListener('resize', this._onResize = () => this.syncScrollThumb(), { passive: true });
      } else {
        this.display(0, true);
      }
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    go(next) {
      if (!this.items.length) return;
      const count = this.items.length;
      this.display(((next % count) + count) % count);
    }

    display(index, instant) {
      if (this.pagination === 'scrollbar') {
        const item = this.items[index];
        if (item && this.viewport) {
          this.viewport.scrollTo({
            left: item.offsetLeft - 8,
            behavior: instant ? 'auto' : 'smooth'
          });
        }
        this.index = index;
        return;
      }

      this.index = index;
      if (this.track) {
        this.track.style.transitionDuration = instant ? '0ms' : '';
        this.track.style.transform = `translateX(-${index * 100}%)`;
      }
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', String(on));
      });
    }

    syncScrollThumb() {
      if (!this.viewport || !this.thumb) return;
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const thumbPct = this.viewport.scrollWidth > 0
        ? Math.min(100, Math.max(18, (this.viewport.clientWidth / this.viewport.scrollWidth) * 100))
        : 100;
      const ratio = max > 0 ? this.viewport.scrollLeft / max : 0;
      this.thumb.style.width = `${thumbPct}%`;
      this.thumb.style.transform = `translateX(${ratio * ((100 / thumbPct) * (100 - thumbPct))}%)`;
    }
  }

  class ProductBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.compareEl = this.querySelector('[data-bundle-compare]');
      this.buttonPriceEl = this.querySelector('[data-bundle-add-price]');
      this.errorEl = this.querySelector('[data-bundle-error]');
      this.submit = this.querySelector('[data-bundle-add]');
      this.discountPercent = Math.max(0, Math.min(90, Number(this.dataset.discountPercent) || 0));

      this.addEventListener('click', (event) => {
        const size = event.target.closest('[data-quick-size]');
        if (!size || !this.contains(size)) return;
        const item = size.closest('[data-bundle-item]');
        if (!item) return;
        item.querySelectorAll('[data-quick-size]').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(btn === size));
        });
        item.dataset.variantId = size.dataset.variantId || '';
        item.dataset.price = size.dataset.price || '0';
        const full = Number(size.dataset.price) || 0;
        const sale =
          this.discountPercent > 0 ? Math.round(full - (full * this.discountPercent) / 100) : full;
        const compareEl = item.querySelector('[data-bundle-item-compare]');
        const saleEl = item.querySelector('[data-bundle-item-sale]');
        if (compareEl && this.discountPercent > 0 && sale < full) {
          compareEl.hidden = false;
          compareEl.textContent = money(full);
          if (saleEl) saleEl.textContent = money(sale);
        } else if (saleEl) {
          if (compareEl) {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
          saleEl.textContent = money(full);
        }
        this.syncTotal();
      });

      this.submit?.addEventListener('click', () => this.addBundle());
      this.syncTotal();
    }

    items() {
      return [...this.querySelectorAll('[data-bundle-item]')];
    }

    syncTotal() {
      const total = this.items().reduce((sum, item) => sum + (Number(item.dataset.price) || 0), 0);
      const sale =
        this.discountPercent > 0
          ? Math.round(total - (total * this.discountPercent) / 100)
          : total;

      if (this.totalEl) {
        if (this.compareEl && this.discountPercent > 0 && sale < total) {
          this.compareEl.hidden = false;
          this.compareEl.textContent = money(total);
          this.totalEl.textContent = money(sale);
        } else {
          if (this.compareEl) {
            this.compareEl.hidden = true;
            this.compareEl.textContent = '';
          }
          this.totalEl.textContent = money(total);
        }
      }

      if (this.buttonPriceEl) {
        this.buttonPriceEl.textContent = money(sale);
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      if (!message) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
        return;
      }
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }

    async addBundle() {
      if (!this.submit || this.submit.disabled || this.submit.classList.contains('is-loading')) return;
      const lines = [];
      for (const item of this.items()) {
        const id = Number(item.dataset.variantId);
        if (!id) {
          this.showError((theme.strings && theme.strings.bundleError) || 'Select a size for each item.');
          return;
        }
        lines.push({ id, quantity: 1 });
      }
      if (lines.length < 2) {
        this.showError((theme.strings && theme.strings.bundleError) || 'Select a size for each item.');
        return;
      }

      this.showError('');
      setAddLoading(this.submit, true);
      try {
        await Cart.addItems(lines);
        await Cart.refresh();
        Cart.open();
      } catch (error) {
        this.showError(error?.message || theme.strings.cartError);
      } finally {
        setAddLoading(this.submit, false);
      }
    }
  }

  class CartExtras extends HTMLElement {
    connectedCallback() {
      this.onSubmit = this.onSubmit.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onNoteInput = this.onNoteInput.bind(this);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onNoteInput);
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onNoteInput);
      clearTimeout(this._noteTimer);
    }

    statusEl() {
      return this.querySelector('[data-cart-discount-status]');
    }

    showStatus(message, isError = false) {
      const status = this.statusEl();
      if (!status) return;
      if (!message) {
        status.hidden = true;
        status.textContent = '';
        status.classList.remove('is-error');
        return;
      }
      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    codeApplied(cart, code) {
      const codes = cart?.discount_codes || [];
      if (!code) return codes.some((item) => item?.applicable !== false);
      const match = codes.find((item) => String(item?.code || '').toLowerCase() === code.toLowerCase());
      if (match) return match.applicable !== false;
      return false;
    }

    async applyCode(code) {
      const trimmed = String(code || '').trim();
      if (!trimmed) return;
      const apply = this.querySelector('[data-cart-discount-apply]');
      if (apply) {
        apply.disabled = true;
        apply.setAttribute('aria-busy', 'true');
      }
      try {
        const cart = await Cart.update({ discount: trimmed });
        if (!this.codeApplied(cart, trimmed)) {
          throw new Error(this.dataset.invalid || theme.strings.cartError);
        }
        this.showStatus(this.dataset.applied || '');
        await Cart.refresh();
      } catch (error) {
        this.showStatus(error?.message || this.dataset.invalid || theme.strings.cartError, true);
      } finally {
        if (apply) {
          apply.disabled = false;
          apply.removeAttribute('aria-busy');
        }
      }
    }

    async clearCode() {
      try {
        await Cart.update({ discount: '' });
        this.showStatus(this.dataset.removed || '');
        await Cart.refresh();
      } catch (error) {
        this.showStatus(error?.message || theme.strings.cartError, true);
      }
    }

    onSubmit(event) {
      if (!event.target.closest('[data-cart-discount-form]')) return;
      event.preventDefault();
      event.stopPropagation();
      const input = this.querySelector('[data-cart-discount]');
      this.applyCode(input?.value);
    }

    onClick(event) {
      const remove = event.target.closest('[data-cart-discount-remove]');
      if (!remove) return;
      event.preventDefault();
      this.clearCode();
    }

    onNoteInput(event) {
      const note = event.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(this._noteTimer);
      this._noteTimer = setTimeout(() => {
        Cart.update({ note: note.value }).catch(() => {});
      }, 450);
    }
  }

  class ProductShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share]');
      this.label = this.querySelector('[data-share-label]');
      this.original = this.label?.textContent || '';
      this.button?.addEventListener('click', () => this.share());
    }

    url() {
      return this.dataset.url || window.location.href;
    }

    async copy() {
      const value = this.url();
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
      }
      const field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    confirm() {
      if (!this.label) return;
      this.label.textContent = this.dataset.copied || this.original;
      clearTimeout(this._copiedTimer);
      this._copiedTimer = setTimeout(() => {
        this.label.textContent = this.original;
      }, 1800);
    }

    async share() {
      const title = this.dataset.title || document.title;
      const url = this.url();
      try {
        if (navigator.share) {
          await navigator.share({ title, url, text: title });
          return;
        }
        await this.copy();
        this.confirm();
      } catch (error) {
        if (error?.name === 'AbortError') return;
        try {
          await this.copy();
          this.confirm();
        } catch (_) {
          /* ignore */
        }
      }
    }
  }

  class QuickBuyDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('[data-quick-buy-panel]');
      this.image = this.querySelector('[data-quick-buy-image]');
      this.name = this.querySelector('[data-quick-buy-name]');
      this.price = this.querySelector('[data-quick-buy-price]');
      this.optionsRoot = this.querySelector('[data-quick-buy-options]');
      this.submit = this.querySelector('[data-quick-buy-submit]');
      this.submitLabel = this.querySelector('[data-quick-buy-submit-label]');
      this.view = this.querySelector('[data-quick-buy-view]');
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onOverlay = this.onOverlay.bind(this);
      this.addEventListener('click', (event) => this.onPanelClick(event));
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('theme:overlay:request', this.onOverlay);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('theme:overlay:request', this.onOverlay);
      if (this.isOpen) scrollLock.unlock();
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    onDocClick(event) {
      const trigger = event.target.closest('[data-quick-buy]');
      if (!trigger || trigger.closest('quick-buy-drawer')) return;
      event.preventDefault();
      event.stopPropagation();
      const card = trigger.closest('.product-card, article');
      const payload = card?.querySelector('[data-quick-buy-payload]');
      if (!payload) return;
      let data;
      try {
        data = JSON.parse(payload.textContent);
      } catch (error) {
        return;
      }
      this.show(data);
    }

    onPanelClick(event) {
      if (event.target.closest('[data-quick-buy-close]')) {
        this.close();
        return;
      }
      const valueBtn = event.target.closest('[data-quick-buy-value]');
      if (valueBtn) {
        event.preventDefault();
        this.select(Number(valueBtn.dataset.optionIndex), valueBtn.dataset.quickBuyValue);
        return;
      }
      if (event.target.closest('a[href]')) this.close();
    }

    onOverlay(event) {
      if (event.detail?.source !== this) this.close();
    }

    onKey(event) {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      this.close();
    }

    show(data) {
      this.product = data;
      const first = (data.variants || []).find((variant) => variant.available) || data.variants?.[0];
      this.selected = [...(first?.options || [])];
      this.render();
      this.open();
    }

    variant() {
      return (this.product?.variants || []).find((variant) =>
        (variant.options || []).every((option, index) => option === this.selected[index])
      );
    }

    select(index, value) {
      this.selected[index] = value;
      let match = this.variant();
      if (!match?.available) {
        match =
          this.product.variants.find((variant) => variant.available && variant.options[index] === value) ||
          this.product.variants.find((variant) => variant.options[index] === value);
        if (match) this.selected = [...match.options];
      }
      this.render();
    }

    valueAvailable(index, label) {
      return (this.product?.variants || []).some(
        (variant) => variant.available && variant.options[index] === label
      );
    }

    escape(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    swatchStyle(swatch) {
      if (!swatch) return '';
      if (swatch.startsWith('#') || swatch.startsWith('rgb')) return `background-color:${swatch}`;
      return `background-image:url("${this.escape(swatch)}")`;
    }

    render() {
      if (!this.product) return;
      const variant = this.variant();
      const image = variant?.image || this.product.image || '';
      const title = this.product.title || '';
      const url = variant ? `${this.product.url}?variant=${variant.id}` : this.product.url;
      if (this.image) {
        this.image.hidden = !image;
        this.image.src = image;
        this.image.alt = title;
      }
      if (this.name) {
        this.name.textContent = title;
        this.name.href = url || '#';
      }
      if (this.view) this.view.href = url || '#';
      if (this.price) {
        const price = Number(variant?.price || 0);
        const compare = Number(variant?.compare || 0);
        if (compare > price) {
          this.price.innerHTML = `<s class="price__compare">${this.escape(money(compare))}</s> <span class="price__current">${this.escape(money(price))}</span>`;
        } else {
          this.price.innerHTML = `<span class="price__current">${this.escape(money(price))}</span>`;
        }
      }
      if (this.optionsRoot) {
        this.optionsRoot.innerHTML = (this.product.options || [])
          .map((option, index) => {
            const values = (option.values || [])
              .map((entry) => {
                const label = entry.label ?? entry;
                const available = this.valueAvailable(index, label);
                const selected = this.selected[index] === label;
                if (option.kind === 'color') {
                  const style = this.swatchStyle(entry.swatch);
                  const chip = style
                    ? `<span class="product-card__swatch-chip" style="${style}"></span>`
                    : `<span class="product-card__swatch-chip product-card__swatch-chip--label">${this.escape(String(label).slice(0, 2))}</span>`;
                  return `<button class="product-card__swatch${selected ? ' is-selected' : ''}${available ? '' : ' is-unavailable'}" type="button" data-quick-buy-value="${this.escape(label)}" data-option-index="${index}" aria-pressed="${selected}" aria-label="${this.escape(label)}">${chip}</button>`;
                }
                return `<button class="quick-add__size${available ? '' : ' is-unavailable'}" type="button" data-quick-buy-value="${this.escape(label)}" data-option-index="${index}" aria-pressed="${selected}"${available ? '' : ' disabled'}>${this.escape(label)}</button>`;
              })
              .join('');
            return `<div class="quick-buy__option"><p class="quick-buy__option-label">${this.escape(option.name)}</p><div class="quick-buy__values option-rail" data-drag-scroll>${values}</div></div>`;
          })
          .join('');
        this.optionsRoot.querySelectorAll('[data-drag-scroll]').forEach((el) => bindDragScroll(el));
      }
      const canAdd = Boolean(variant?.available && variant.id);
      if (this.submit) {
        this.submit.dataset.variantId = canAdd ? String(variant.id) : '';
        this.submit.disabled = !canAdd;
        this.submit.setAttribute('aria-disabled', String(!canAdd));
      }
      if (this.submitLabel) {
        this.submitLabel.textContent = canAdd
          ? theme.strings.addToCart || 'Add to cart'
          : theme.strings.soldOut || 'Sold out';
      }
      clearAddError(this.submit);
    }

    open() {
      if (this.isOpen) return;
      document.dispatchEvent(new CustomEvent('theme:overlay:request', { detail: { source: this } }));
      this.lastFocused = document.activeElement;
      scrollLock.lock();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      this.release = trapFocus(this.panel);
      document.addEventListener('keydown', this.onKey);
      this.panel?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('theme:overlay', { detail: { open: true, id: this.id } }));
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      scrollLock.unlock();
      this.release?.();
      document.removeEventListener('keydown', this.onKey);
      document.dispatchEvent(new CustomEvent('theme:overlay', { detail: { open: false, id: this.id } }));
      this.lastFocused?.focus?.({ preventScroll: true });
    }
  }

  const define = (name, constructor) => {
    if (!customElements.get(name)) customElements.define(name, constructor);
  };

  define('cart-extras', CartExtras);
  define('product-share', ProductShare);
  define('cart-drawer', CartDrawer);
  define('product-form', ProductForm);

  define('contact-form', ContactForm);
  define('collection-slider', CollectionSlider);
  define('footer-menus', FooterMenus);
  define('footer-wordmark', FooterWordmark);
  define('localization-form', LocalizationForm);
  define('launch-about', LaunchAbout);
  define('launch-countdown', LaunchCountdown);
  define('media-gallery', MediaGallery);
  define('size-chart', SizeChart);
  define('product-accordion', ProductAccordion);
  define('product-tabs', ProductTabs);
  define('collection-grid', CollectionGrid);
  define('product-card-gallery', ProductCardGallery);
  define('product-trust', ProductTrust);
  define('product-bundle', ProductBundle);
  define('quick-buy-drawer', QuickBuyDrawer);

  const syncSearchClear = (input) => {
    const clear = input.closest('.search-page__field')?.querySelector('[data-search-clear]');
    if (clear) clear.hidden = !String(input.value || '').trim();
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.search-page__input');
    if (input) syncSearchClear(input);
  });

  document.addEventListener('click', (event) => {
    const clear = event.target.closest?.('[data-search-clear]');
    if (!clear) return;
    const input = clear.closest('.search-page__field')?.querySelector('.search-page__input');
    if (!input) return;
    input.value = '';
    syncSearchClear(input);
    input.focus();
  });

  /* Product card color swatches — gallery + indicators + quick-add sync */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.product-card');
    const group = swatch.closest('[data-card-swatches]');
    if (!card || !group) return;

    const colorValue = swatch.getAttribute('data-color-value') || '';
    let payload = null;
    try {
      const raw = card.querySelector('[data-card-variants]')?.textContent || '{}';
      payload = JSON.parse(raw);
    } catch (_) {
      payload = null;
    }
    if (!payload || !Array.isArray(payload.variants)) return;

    const colorIndex = Number(payload.colorIndex);
    const sizeIndex = payload.sizeIndex == null ? null : Number(payload.sizeIndex);
    const colorVariants = payload.variants.filter(
      (variant) => String((variant.options || [])[colorIndex] || '') === String(colorValue)
    );
    if (!colorVariants.length) return;

    group.querySelectorAll('[data-card-swatch]').forEach((btn) => {
      const on = btn === swatch;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* Release focus so hover-mode rows can hide when the pointer leaves the card */
    if (typeof swatch.blur === 'function') swatch.blur();

    const images = [];
    const seen = new Set();
    colorVariants.forEach((variant) => {
      if (!variant.src || seen.has(variant.src)) return;
      seen.add(variant.src);
      images.push(variant.src);
    });
    if (!images.length && Array.isArray(payload.media)) {
      const needle = String(colorValue).toLowerCase();
      payload.media.forEach((item) => {
        const alt = String(item.alt || '').toLowerCase();
        if (needle && alt.includes(needle) && item.src && !seen.has(item.src)) {
          seen.add(item.src);
          images.push(item.src);
        }
      });
    }
    if (!images.length && colorVariants[0]?.src) images.push(colorVariants[0].src);

    const sizeValues = [];
    const sizes = [];
    if (sizeIndex != null && !Number.isNaN(sizeIndex)) {
      colorVariants.forEach((variant) => {
        const value = (variant.options || [])[sizeIndex];
        if (value == null || sizeValues.includes(value)) return;
        sizeValues.push(value);
        sizes.push({
          value,
          id: variant.id,
          available: Boolean(variant.available),
          price: variant.price || '',
          compare: variant.compare || '',
          url: variant.url || ''
        });
      });
      /* Prefer available size rows when duplicates exist for same label */
      const byValue = new Map();
      colorVariants.forEach((variant) => {
        const value = (variant.options || [])[sizeIndex];
        if (value == null) return;
        const prev = byValue.get(value);
        if (!prev || (!prev.available && variant.available)) {
          byValue.set(value, {
            value,
            id: variant.id,
            available: Boolean(variant.available),
            price: variant.price || '',
            compare: variant.compare || '',
            url: variant.url || ''
          });
        }
      });
      sizes.length = 0;
      byValue.forEach((row) => sizes.push(row));
    } else {
      const pick =
        colorVariants.find((variant) => variant.available) || colorVariants[0];
      if (pick) {
        sizes.push({
          value: '',
          id: pick.id,
          available: Boolean(pick.available),
          price: pick.price || '',
          compare: pick.compare || '',
          url: pick.url || ''
        });
      }
    }

    const pick =
      colorVariants.find((variant) => variant.available) || colorVariants[0];
    const url = pick?.url || sizes.find((s) => s.available)?.url || sizes[0]?.url;
    if (url) {
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        link.href = url;
      });
    }

    const gallery = card.querySelector('product-card-gallery');
    const track = gallery?.querySelector('[data-card-track]');
    const dotsWrap = gallery?.querySelector('[data-card-dots]');

    if (gallery) {
      gallery.setAttribute('data-color-locked', 'true');
    }

    if (track && images.length) {
      track.innerHTML = images
        .map(
          (src, i) =>
            `<div class="product-card__slide${i === 0 ? ' is-active' : ''}" data-card-slide><img class="product-card__image" src="${src}" alt="" loading="lazy" decoding="async"></div>`
        )
        .join('');

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        dotsWrap.hidden = true;
      }

      const nav = gallery?.querySelector('[data-card-nav]');
      if (nav) nav.hidden = true;

      if (gallery) {
        gallery.slides = [...gallery.querySelectorAll('[data-card-slide]')];
        gallery.dots = [];
        gallery.index = 0;
        gallery.hovering = false;
        gallery.autoplayOrigin = null;
        gallery.stopAutoplay?.();
        if (typeof gallery.bind === 'function') gallery.bind();
        if (typeof gallery.display === 'function') gallery.display(0, true);
      }
    }

    const price = pick?.price || sizes.find((s) => s.available)?.price || sizes[0]?.price || '';
    const compare = pick?.compare || sizes.find((s) => s.available)?.compare || '';
    const priceRoot = card.querySelector('.price');
    if (priceRoot && price) {
      const sale = priceRoot.querySelector('.price__sale');
      const regular = priceRoot.querySelector('.price__regular');
      const compareEl = priceRoot.querySelector('.price__compare');
      if (compare && (sale || regular)) {
        if (sale) sale.textContent = price;
        if (regular) {
          regular.textContent = price;
          regular.hidden = true;
        }
        if (compareEl) {
          compareEl.textContent = compare;
          compareEl.hidden = false;
        }
        priceRoot.classList.add('price--on-sale');
      } else {
        if (regular) {
          regular.textContent = price;
          regular.hidden = false;
        }
        if (sale) sale.textContent = price;
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
        priceRoot.classList.remove('price--on-sale');
      }
    }

    const quick = card.querySelector('[data-quick-add-root]');
    if (quick) {
      const availableSizes = sizes.filter((s) => s.available);
      const colorSoldOut = availableSizes.length === 0;
      const soldLabel = theme?.strings?.soldOut || 'Sold out';
      const addLabel = theme?.strings?.addToCart || 'Add to cart';

      let sizesEl = quick.querySelector('.quick-add__sizes');
      let soldEl = quick.querySelector('.quick-add__sold-out');
      const submit = quick.querySelector('[data-quick-add]');

      if (colorSoldOut) {
        if (sizesEl) {
          sizesEl.innerHTML = '';
          sizesEl.hidden = true;
          const rail = sizesEl.closest('[data-option-rail]');
          if (rail) rail.hidden = true;
        }
        if (soldEl) soldEl.hidden = true;
        if (submit) {
          submit.disabled = true;
          submit.dataset.variantId = '';
          submit.setAttribute('aria-label', soldLabel);
        }
        card.classList.add('product-card--sold-out');
      } else {
        if (soldEl) soldEl.hidden = true;
        card.classList.remove('product-card--sold-out');

        if (sizes.length && sizes.some((s) => s.value)) {
          if (!sizesEl) {
            sizesEl = document.createElement('div');
            sizesEl.className = 'quick-add__sizes';
            sizesEl.setAttribute('role', 'list');
            sizesEl.setAttribute('data-drag-scroll', '');
            const rail = document.createElement('div');
            rail.className = 'option-rail';
            rail.setAttribute('data-option-rail', '');
            rail.appendChild(sizesEl);
            if (submit) submit.insertAdjacentElement('afterend', rail);
            else quick.appendChild(rail);
          } else {
            if (!sizesEl.hasAttribute('data-drag-scroll')) {
              sizesEl.setAttribute('data-drag-scroll', '');
            }
            if (!sizesEl.closest('[data-option-rail]')) {
              const rail = document.createElement('div');
              rail.className = 'option-rail';
              rail.setAttribute('data-option-rail', '');
              sizesEl.parentNode.insertBefore(rail, sizesEl);
              rail.appendChild(sizesEl);
            }
          }
          sizesEl.hidden = false;
          const railEl = sizesEl.closest('[data-option-rail]');
          const compact = quick.dataset.quickAddLayout === 'compact';
          if (railEl) {
            railEl.classList.add('quick-add__rail');
            if (compact && !quick.classList.contains('is-open')) {
              railEl.hidden = true;
            } else {
              railEl.hidden = false;
            }
          }
          if (compact && submit) {
            quick.setAttribute('data-quick-add-expandable', 'true');
            submit.setAttribute('aria-expanded', quick.classList.contains('is-open') ? 'true' : 'false');
          }
          sizesEl.innerHTML = sizes
            .map((s) => {
              if (!s.available) {
                return `<button class="quick-add__size is-unavailable" type="button" role="listitem" disabled aria-disabled="true" data-size="${String(s.value).replace(/"/g, '&quot;')}">${s.value}</button>`;
              }
              return `<button class="quick-add__size" type="button" role="listitem" data-quick-size data-variant-id="${s.id}" data-size="${String(s.value).replace(/"/g, '&quot;')}" aria-pressed="false">${s.value}</button>`;
            })
            .join('');

          bindDragScroll(sizesEl);

          const firstSize = sizesEl.querySelector('[data-quick-size]');
          if (firstSize) {
            firstSize.setAttribute('aria-pressed', 'true');
            if (submit) {
              submit.disabled = false;
              submit.dataset.variantId = firstSize.dataset.variantId;
              submit.setAttribute('aria-label', `${addLabel}`);
            }
          }
        } else {
          if (sizesEl) {
            sizesEl.hidden = true;
            const rail = sizesEl.closest('[data-option-rail]');
            if (rail) rail.hidden = true;
          }
          quick.removeAttribute('data-quick-add-expandable');
          quick.classList.remove('is-open');
          if (submit) submit.removeAttribute('aria-expanded');
          const only = availableSizes[0] || sizes[0];
          if (submit && only) {
            submit.disabled = false;
            submit.dataset.variantId = String(only.id);
            submit.setAttribute('aria-label', addLabel);
          }
        }
      }
    }
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-footer-scroll-top]');
    if (!btn) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  class EmailPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.dialog = this.querySelector('[data-email-popup-dialog]');
      this.form = this.querySelector('form');
      this.input = this.querySelector('[data-email-popup-input]');
      this.submit = this.querySelector('[data-email-popup-submit]');
      this.success = this.querySelector('[data-email-popup-success]');
      this.content = this.querySelector('[data-email-popup-content]');
      this.copyButton = this.querySelector('[data-email-popup-copy]');
      this.codeEl = this.querySelector('[data-email-popup-code]');
      this.storageKey = 'wv:email-popup';
      this.mode = this.dataset.mode || 'live';
      this.trigger = this.dataset.trigger || 'delay';
      this.frequency = this.dataset.frequency || 'session';
      this.delayMs = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
      this.scrollPercent = Math.min(100, Math.max(1, Number(this.dataset.scroll) || 50));
      this.days = Math.max(1, Number(this.dataset.days) || 14);
      this.hasOffer = this.dataset.hasOffer === 'true';
      /* Edit preview only when Theme Editor + Mode=Edit. Never on live storefront. */
      this.isEditPreview =
        this.dataset.editPreview === 'true' &&
        Boolean(window.Shopify && window.Shopify.designMode);
      this.open = false;
      this.exitArmed = true;
      this.releaseFocus = null;
      this.timers = [];
      this.copyTimer = null;

      this.onKeydown = this.onKeydown.bind(this);
      this.onDismiss = this.onDismiss.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onExitIntent = this.onExitIntent.bind(this);
      this.onScrollTrigger = this.onScrollTrigger.bind(this);
      this.onCopy = this.onCopy.bind(this);

      this.querySelectorAll('[data-email-popup-dismiss]').forEach((el) => {
        el.addEventListener('click', this.onDismiss);
      });
      this.form?.addEventListener('submit', this.onSubmit);
      this.form?.setAttribute('novalidate', '');
      this.copyButton?.addEventListener('click', this.onCopy);

      if (this.isEditPreview) {
        this.openPopup({ force: true });
        return;
      }

      if (this.querySelector('[data-email-popup-posted]')) {
        this.persist();
        this.showSuccess(true);
        return;
      }

      if (this.hasSeen()) return;
      this.armTrigger();
    }

    disconnectedCallback() {
      this.teardownTriggers();
      document.removeEventListener('keydown', this.onKeydown);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.copyButton?.removeEventListener('click', this.onCopy);
      this.querySelectorAll('[data-email-popup-dismiss]').forEach((el) => {
        el.removeEventListener('click', this.onDismiss);
      });
      if (this.copyTimer) window.clearTimeout(this.copyTimer);
      if (this.open) this.close(false);
    }

    storage() {
      try {
        return this.frequency === 'session' ? window.sessionStorage : window.localStorage;
      } catch (error) {
        return null;
      }
    }

    hasSeen() {
      if (this.isEditPreview) return false;
      const store = this.storage();
      if (!store) return false;
      const raw = store.getItem(this.storageKey);
      if (!raw) return false;
      if (this.frequency !== 'days') return true;
      const stamped = Number(raw);
      if (!Number.isFinite(stamped)) return true;
      const expires = stamped + this.days * 86400000;
      return Date.now() < expires;
    }

    persist() {
      if (this.isEditPreview) return;
      const store = this.storage();
      if (!store) return;
      try {
        store.setItem(this.storageKey, this.frequency === 'days' ? String(Date.now()) : '1');
      } catch (error) {
        /* Storage blocked — ignore. */
      }
    }

    armTrigger() {
      if (this.isEditPreview) return;

      if (this.trigger === 'exit_intent') {
        document.addEventListener('mouseout', this.onExitIntent);
        return;
      }

      if (this.trigger === 'scroll') {
        window.addEventListener('scroll', this.onScrollTrigger, { passive: true });
        this.onScrollTrigger();
        return;
      }

      const id = window.setTimeout(() => this.openPopup(), this.delayMs);
      this.timers.push(id);
    }

    teardownTriggers() {
      document.removeEventListener('mouseout', this.onExitIntent);
      window.removeEventListener('scroll', this.onScrollTrigger);
      this.timers.forEach((id) => window.clearTimeout(id));
      this.timers = [];
      if (this._enterObserver) {
        this._enterObserver.disconnect();
        this._enterObserver = null;
      }
    }

    enterGateActive() {
      return document.documentElement.classList.contains('has-enter-page');
    }

    deferUntilEnterDismissed(run) {
      if (!this.enterGateActive()) {
        run();
        return;
      }
      if (this._enterObserver) return;
      this._enterObserver = new MutationObserver(() => {
        if (this.enterGateActive()) return;
        this._enterObserver?.disconnect();
        this._enterObserver = null;
        run();
      });
      this._enterObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    onExitIntent(event) {
      if (this.open || this.isEditPreview || !this.exitArmed) return;
      if (event.clientY > 0) return;
      if (event.relatedTarget || event.toElement) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      this.exitArmed = false;
      this.teardownTriggers();
      this.openPopup();
    }

    onScrollTrigger() {
      if (this.open || this.isEditPreview) return;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const progress = (window.scrollY / max) * 100;
      if (progress < this.scrollPercent) return;
      this.teardownTriggers();
      this.openPopup();
    }

    openPopup({ force = false } = {}) {
      if (this.open) return;
      if (!force && this.hasSeen()) return;
      /* Enter gate hides the popup visually but kept is-open — that buried the music player. */
      if (!force && this.enterGateActive()) {
        this.deferUntilEnterDismissed(() => this.openPopup({ force }));
        return;
      }
      this.open = true;
      this.teardownTriggers();
      this.hidden = false;
      this.removeAttribute('hidden');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
      });
      scrollLock.lock();
      this.releaseFocus = trapFocus(this.dialog || this);
      document.addEventListener('keydown', this.onKeydown);
      if (!this.isEditPreview) {
        window.setTimeout(() => this.input?.focus(), 20);
      }
    }

    close(persist = true) {
      if (this.isEditPreview) return;
      if (!this.open && this.hidden) return;
      this.open = false;
      this.classList.remove('is-open');
      this.hidden = true;
      this.setAttribute('hidden', '');
      document.removeEventListener('keydown', this.onKeydown);
      this.releaseFocus?.();
      this.releaseFocus = null;
      scrollLock.unlock();
      if (persist) this.persist();
      const resetUi = () => {
        if (this.open) return;
        this.classList.remove('is-success');
        this.success?.setAttribute('hidden', '');
        this.content?.removeAttribute('hidden');
        if (this.submit) {
          this.submit.disabled = false;
          this.submit.removeAttribute('aria-disabled');
        }
        if (this.copyButton) {
          this.copyButton.textContent = this.copyButton.dataset.copyLabel || this.copyButton.textContent;
        }
      };
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320;
      if (duration) window.setTimeout(resetUi, duration);
      else resetUi();
    }

    onDismiss(event) {
      event.preventDefault();
      if (this.isEditPreview) return;
      this.close(true);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.isEditPreview) return;
        this.close(true);
      }
    }

    showSuccess(fromReload = false) {
      this.classList.add('is-success');
      this.content?.setAttribute('hidden', '');
      this.success?.removeAttribute('hidden');
      if (fromReload && !this.isEditPreview) {
        this.open = true;
        this.hidden = false;
        this.removeAttribute('hidden');
        requestAnimationFrame(() => this.classList.add('is-open'));
        scrollLock.lock();
        this.releaseFocus = trapFocus(this.dialog || this);
        document.addEventListener('keydown', this.onKeydown);
      }
      if (this.isEditPreview) return;
      /* Keep open when an offer/code is shown so visitors can copy it. */
      if (!this.hasOffer) {
        window.setTimeout(() => this.close(true), fromReload ? 2200 : 1600);
      } else {
        window.setTimeout(() => this.copyButton?.focus(), 40);
      }
    }

    async onCopy() {
      const code = this.codeEl?.textContent?.trim();
      if (!code || !this.copyButton) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(this.codeEl);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        try {
          document.execCommand('copy');
        } catch (copyError) {
          /* Clipboard unavailable. */
        }
        selection?.removeAllRanges();
      }
      const copied = this.copyButton.dataset.copiedLabel || 'Copied';
      const original = this.copyButton.dataset.copyLabel || this.copyButton.textContent;
      this.copyButton.textContent = copied;
      if (this.copyTimer) window.clearTimeout(this.copyTimer);
      this.copyTimer = window.setTimeout(() => {
        this.copyButton.textContent = original;
      }, 1800);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.form || this.submit?.disabled) return;

      const email = this.input?.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.input?.focus();
        return;
      }

      const genderInput = this.form.querySelector('[data-email-popup-gender]');
      const genderPicked = this.form.querySelector('[data-email-popup-gender]:checked');
      if (genderInput && !genderPicked) {
        genderInput.focus();
        return;
      }

      const tags = this.form.querySelector('[data-email-popup-tags]');
      if (tags) {
        const base = tags.dataset.baseTags || 'newsletter, email-popup';
        tags.value = genderPicked ? `${base}, ${genderPicked.value}` : base;
      }

      this.submit.disabled = true;
      this.submit.setAttribute('aria-disabled', 'true');

      if (this.isEditPreview) {
        this.showSuccess(false);
        this.submit.disabled = false;
        this.submit.removeAttribute('aria-disabled');
        return;
      }

      try {
        const body = new FormData(this.form);
        const action = (this.form.getAttribute('action') || this.form.action || '/contact').split('#')[0] || '/contact';
        await fetch(action, {
          method: (this.form.getAttribute('method') || 'POST').toUpperCase(),
          body,
          credentials: 'same-origin',
          redirect: 'manual',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      } catch (error) {
        /* Stay in the popup. Native submit would reload the page. */
      }
      this.persist();
      this.showSuccess(false);
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('email-popup') && !form.matches('[data-email-popup-form]')) return;
      event.preventDefault();
    },
    true
  );

  define('email-popup', EmailPopup);

  class AccountWishlist extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.empty = this.querySelector('[data-account-wishlist-empty]');
      this.grid = this.querySelector('[data-account-wishlist-grid]');
      this._token = 0;
      this.render = this.render.bind(this);
      document.addEventListener('theme:wishlist:change', this.render);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('theme:wishlist:change', this.render);
    }

    rootUrl() {
      return window.Shopify?.routes?.root || '/';
    }

    async render() {
      const items = Wishlist.read();
      if (!items.length) {
        if (this.grid) {
          this.grid.innerHTML = '';
          this.grid.hidden = true;
        }
        if (this.empty) this.empty.hidden = false;
        return;
      }
      const token = ++this._token;
      const handles = items.map((item) => item.handle).filter(Boolean);
      const pairs = await Promise.all(
        handles.map(async (handle) => ({
          handle,
          html: await this.fetchCard(handle).catch(() => '')
        }))
      );
      if (token !== this._token) return;
      const ok = pairs.filter((pair) => pair.html);
      const bad = pairs.filter((pair) => !pair.html).map((pair) => pair.handle);
      if (bad.length) Wishlist.pruneHandles(bad);
      const markup = ok.map((pair) => pair.html).join('');
      if (!markup) {
        if (this.grid) {
          this.grid.innerHTML = '';
          this.grid.hidden = true;
        }
        if (this.empty) this.empty.hidden = false;
        return;
      }
      if (this.empty) this.empty.hidden = true;
      if (this.grid) {
        this.grid.hidden = false;
        this.grid.innerHTML = markup;
        this.grid.querySelectorAll('.reveal, .product-card-reveal').forEach((el) => {
          el.classList.add('is-visible');
        });
        Wishlist.sync(this);
        window.MediaStates?.initAll?.(this.grid);
      }
    }

    async fetchCard(handle) {
      const response = await fetch(
        `${this.rootUrl()}products/${encodeURIComponent(handle)}?section_id=wishlist-item`,
        { credentials: 'same-origin' }
      );
      if (!response.ok) return '';
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const item = doc.querySelector('[data-wishlist-handle]');
      return item ? item.outerHTML : '';
    }
  }

  define('account-wishlist', AccountWishlist);

  const syncNewsletterAgreement = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const checkbox = form.querySelector('[data-newsletter-agreement]');
    const button = form.querySelector('[data-newsletter-submit]');
    if (!checkbox || !button) return;
    const blocked = !checkbox.checked;
    button.disabled = blocked;
    button.setAttribute('aria-disabled', String(blocked));
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('[data-newsletter-agreement]')) return;
    syncNewsletterAgreement(event.target.closest('form'));
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const checkbox = form.querySelector('[data-newsletter-agreement]');
      if (!checkbox) return;
      if (checkbox.checked) return;
      event.preventDefault();
      event.stopPropagation();
      syncNewsletterAgreement(form);
    },
    true
  );

  const initNewsletterAgreements = (root = document) => {
    root.querySelectorAll('form').forEach((form) => {
      if (form.querySelector('[data-newsletter-agreement]')) syncNewsletterAgreement(form);
    });
  };

  /* Page/product reveals — always on. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      reveal.init();
      bannerEntrance.init();
      document.querySelectorAll('.product[data-reveal-group]').forEach((group) => pageReveal.play(group));
      Wishlist.boot();
      Wishlist.sync();
      document.querySelectorAll('[data-drag-scroll]').forEach(bindDragScroll);
      initNewsletterAgreements();
    }, { once: true });
  } else {
    reveal.init();
    bannerEntrance.init();
    document.querySelectorAll('.product[data-reveal-group]').forEach((group) => pageReveal.play(group));
    Wishlist.boot();
    Wishlist.sync();
    document.querySelectorAll('[data-drag-scroll]').forEach(bindDragScroll);
    initNewsletterAgreements();
  }

  window.addEventListener('storage', (event) => {
    if (!event.key || (event.key !== Wishlist.key && !event.key.startsWith(Wishlist.accountPrefix))) return;
    Wishlist.sync();
    document.dispatchEvent(new CustomEvent('theme:wishlist:change'));
  });

  /* Section rendering in the Theme Editor swaps markup: re-scan for reveals
     and re-bind payment-icon drag scroll on the new nodes. */
  document.addEventListener('shopify:section:load', (event) => {
    if (!document.documentElement.classList.contains('has-enter-page')) {
      reveal.scan(event.target);
      bannerEntrance.scan(event.target);
      event.target.querySelectorAll('.product[data-reveal-group]').forEach((group) => pageReveal.play(group));
    }
    Wishlist.sync(event.target);
    event.target.querySelectorAll('[data-drag-scroll]').forEach(bindDragScroll);
    initNewsletterAgreements(event.target);
  });

  /* ============================================
     SCROLL GRADIENT EFFECT
     ============================================ */
  const initScrollGradient = () => {
    const scrollGradient = document.querySelector('.bg-scroll-gradient');
    if (!scrollGradient) return;

    let ticking = false;
    const updateGradient = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = docHeight > 0 ? (scrollY / docHeight) * 100 : 0;
      
      /* Move background position based on scroll (0% to 100%) */
      scrollGradient.style.backgroundPosition = `${scrollPercent}% ${scrollPercent}%`;
      
      /* Also rotate the angle slightly for extra effect */
      const angle = 135 + (scrollPercent * 0.9);
      scrollGradient.style.setProperty('--scroll-gradient-angle', `${angle}deg`);
      
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateGradient);
        ticking = true;
      }
    }, { passive: true });

    updateGradient();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollGradient, { once: true });
  } else {
    initScrollGradient();
  }
})();
